export const etkinlikler = [
  {
    "id": "arkadaslik-haftasi",
    "title": "ARKADAŞLIK HAFTASI",
    "image": "/files/images/l1611201821374138.jpg",
    "description": "ARKADAŞLIK HAFTASIGelişim Koleji \"Arkadaşlık Haftası\" 11-15 Aralık tarihleri arasında kutlanıyor.\"Arkadaşlık Haftası\" bünyesinde rehberlik birimi tarafindan düzenlenen etkinliklerimiz bugün  öğrencilerimizin yoğun katılımıyla başlamıştır.",
    "gallery": [
      "/files/images/l11122017232222849.jpg",
      "/files/images/l111220172323225.jpg",
      "/files/images/l11122017232322130.jpg",
      "/files/images/l11122017232322349.jpg",
      "/files/images/l11122017232322489.jpg",
      "/files/images/l11122017232322630.jpg",
      "/files/images/l11122017232322771.jpg",
      "/files/images/l1112201723242221.jpg",
      "/files/images/l11122017232422146.jpg",
      "/files/images/l11122017232422271.jpg",
      "/files/images/l11122017232422474.jpg",
      "/files/images/l11122017232422599.jpg",
      "/files/images/l11122017232422724.jpg",
      "/files/images/l11122017232422849.jpg",
      "/files/images/l11122017232422989.jpg",
      "/files/images/l11122017232522114.jpg",
      "/files/images/l11122017232522239.jpg",
      "/files/images/l11122017232522333.jpg",
      "/files/images/l11122017232522458.jpg",
      "/files/images/l11122017232522583.jpg",
      "/files/images/l11122017232522708.jpg",
      "/files/images/l1112201723262236.jpg",
      "/files/images/l11122017232622193.jpg",
      "/files/images/l11122017232622318.jpg",
      "/files/images/l11122017232622536.jpg",
      "/files/images/l11122017232622661.jpg",
      "/files/images/l11122017232622771.jpg",
      "/files/images/l11122017232622911.jpg",
      "/files/images/l1112201723272237.jpg",
      "/files/images/l11122017232722271.jpg",
      "/files/images/l11122017232722414.jpg",
      "/files/images/l11122017232722526.jpg",
      "/files/images/l11122017232722646.jpg",
      "/files/images/l11122017232722849.jpg"
    ],
    "video": ""
  },
  {
    "id": "5-siniflarimizin-antalya-kampi",
    "title": "5. Sınıflarımızın Antalya Kampı",
    "image": "/images2/img2_files/logo.jpg",
    "description": "5. Sınıflarımızın Antalya Kampı2017-2018 Eğitim-Öğretim Yılı içerisinde her yıl 5. Sınıflara yönelik düzenlemiş olduğumuzAntalya-Side kampını 06-10 Kasım tarihleri arasında gerçekleştirdik.Öğrencilerimizin kamp süresi boyunca ailelerinden uzakta sorumluluk bilincini, gözlem yeteneklerini geliştirerek, arkadaşlarıyla uyumlu, paylaşımcı olmalarını sağlamak, sosyal çevre ile ilişkilerini güçlendirmek amaçlanmıştır.Ayrıca öğrencilerimizin “Aspendos, Side Antik Kent, Apollon Tapınağı, Alanya” gibi tarihi yerleri gezip, görerek tarihi şuurun toplumda yerleşmesini ve gelişmesini sağlayarak gelecek nesillere köprü olan kültürümüzün unutulmaması ideallerimizi gerçekleştirdik.Öğrencilerimiz ile gerçekleştirmiş olduğumuz “Titreyen Göl ve Manavgat Şelalesi” gezisinde öğrencilerimizin doğaya saygılı, ekolojiye bağlı bireyler olmasını sağlamak, ayrıca sanatın, spor etkinliklerinin, müzik ve dansın katkısıyla öğrencilerimizin sosyo-psikolojik gelişimine yardımcı olarak öğrencilerimizle eğlenceli, güzel vakit geçirdik. Kamp süresinde etütlerimiz bilgi yarışmamız ile öğrencilerimizin bilgilerini pekiştirmelerini sağladık.10 Kasım Cuma günü saat 09:05’te Ulu ÖnderimizMustafa Kemal Atatürk’ün 79. ölüm yıl dönümünü andık.Öğrencilerimiz mutlu, enerjik ve heyecanlı bir şekilde gezi sonunda aileleri ile buluştular.1. GÜN2. GÜN2. Gün Disko3. Gün4. Gün5. Gün",
    "gallery": [],
    "video": "https://www.youtube.com/embed/7HkXIpMpj9Q?ecver=1"
  },
  {
    "id": "6-siniflarimizin-resim-sergisi",
    "title": "6. Sınıflarımızın Resim Sergisi",
    "image": "/files/images/l510201893934631.jpg",
    "description": "6. Sınıflarımızın Resim Sergisi6. Sınıflarımız Hayvanları Koruma Günü için hazırladıları resimleri sergiliyor.",
    "gallery": [
      "/files/images/l510201893934631.jpg",
      "/files/images/l510201894034225.jpg",
      "/files/images/l510201894034866.jpg"
    ],
    "video": ""
  },
  {
    "id": "gunesdunyaay",
    "title": "Güneş-Dünya-Ay",
    "image": "/files/images/l210201814377333.JPG",
    "description": "Güneş-Dünya-AyFen Bilimleri dersinde 5. sınıf 1. ünitemiz olan \"Güneş, Dünya, Ay\" konusunun maketlerini öğrencilerimiz büyük bir keyifle yaptılar.",
    "gallery": [
      "/files/images/l210201814377333.JPG",
      "/files/images/l210201814377864.JPG",
      "/files/images/l210201814387458.JPG",
      "/files/images/l210201814387974.JPG",
      "/files/images/l210201814397505.JPG",
      "/files/images/l21020181440752.JPG",
      "/files/images/l210201814407598.JPG",
      "/files/images/l210201814417114.JPG",
      "/files/images/l210201814417645.JPG",
      "/files/images/l210201814427208.JPG"
    ],
    "video": ""
  },
  {
    "id": "sanat-haftasi-resitaller-5-6-ve-7-siniflarimiz",
    "title": "Sanat Haftası Resitaller 5. 6. ve 7. Sınıflarımız",
    "image": "/files/images/l4620181451316.JPG",
    "description": "Sanat Haftası Resitaller 5. 6. ve 7. SınıflarımızGüney Gelişim Okulları Sanat Haftası kapsamında düzenlenen 5. 6. ve 7.sınıflarımızın resitallerini gerçekleştirdik.  Öğrencilerimizi göstermiş oldukları çaba ve emekten dolayı kutluyor, başarılarının artarak devam etmesini diliyoruz.",
    "gallery": [
      "/files/images/l4620181451316.JPG",
      "/files/images/l4620181451457.JPG",
      "/files/images/l4620181451598.JPG",
      "/files/images/l4620181451738.JPG",
      "/files/images/l4620181451863.JPG",
      "/files/images/l4620181451988.JPG",
      "/files/images/l4620181461145.JPG",
      "/files/images/l4620181461285.JPG",
      "/files/images/l4620181461426.JPG",
      "/files/images/l4620181461566.JPG",
      "/files/images/l4620181461723.JPG",
      "/files/images/l4620181461879.JPG",
      "/files/images/l462018147120.JPG",
      "/files/images/l4620181471160.JPG",
      "/files/images/l4620181471301.JPG",
      "/files/images/l4620181471457.JPG",
      "/files/images/l4620181471613.JPG",
      "/files/images/l4620181471785.JPG",
      "/files/images/l4620181471941.JPG",
      "/files/images/l4620181481114.JPG",
      "/files/images/l4620181481285.JPG",
      "/files/images/l4620181481435.JPG",
      "/files/images/l4620181481614.JPG",
      "/files/images/l4620181481738.JPG",
      "/files/images/l4620181481894.JPG",
      "/files/images/l462018149120.JPG",
      "/files/images/l4620181491160.JPG",
      "/files/images/l4620181491301.JPG",
      "/files/images/l4620181491426.JPG",
      "/files/images/l4620181491566.JPG",
      "/files/images/l4620181491707.JPG",
      "/files/images/l4620181491848.JPG",
      "/files/images/l4620181491988.JPG",
      "/files/images/l46201814101113.JPG",
      "/files/images/l46201814101254.JPG",
      "/files/images/l46201814101394.JPG",
      "/files/images/l46201814101520.JPG",
      "/files/images/l46201814101660.JPG",
      "/files/images/l46201814101816.JPG",
      "/files/images/l46201814101957.JPG",
      "/files/images/l4620181411198.JPG",
      "/files/images/l46201814111238.JPG",
      "/files/images/l46201814111379.JPG",
      "/files/images/l46201814111519.JPG"
    ],
    "video": "http://dizihitplayer.xyz/player/flex/c984161d83ef770595183409e3d1bbc2"
  },
  {
    "id": "kucuk-erkekler-optimist-il-ikinciligi",
    "title": "Küçük Erkekler Optimist İl İkinciliği",
    "image": "/files/images/l2052018124457226.jpg",
    "description": "Küçük Erkekler Optimist İl İkinciliğiMersinde düzenlenen Küçük Erkekler Optimist Müsabakasında Öğrencimiz Mersin 2.si olmuştur.",
    "gallery": [
      "/files/images/l2052018124457226.jpg"
    ],
    "video": ""
  },
  {
    "id": "mini-voleybol-senligi",
    "title": "Mini Voleybol Şenliği",
    "image": "/files/images/l1852018174515697.jpg",
    "description": "Mini Voleybol Şenliğiİlimizde Duzenlenen Mini Voleybol Şenliğinde Okulumuzun Kulüp Takımı Mersin 2.si olmuştur.",
    "gallery": [
      "/files/images/l1852018174515697.jpg"
    ],
    "video": ""
  },
  {
    "id": "yildiz-erkek-tenis-takimimiz-turkiye-finallerinde",
    "title": "Yıldız Erkek Tenis Takımımız Türkiye Finallerinde",
    "image": "/files/images/l1752018142937869.jpg",
    "description": "Yıldız Erkek Tenis Takımımız Türkiye FinallerindeOkullarasi Yıldız Erkekler Bölge Şampiyonluğu Yıldız Erkek Tenis Takımımız Türkiye Finallerinde ...",
    "gallery": [
      "/files/images/l1752018142937869.jpg",
      "/files/images/l1752018142937963.jpg",
      "/files/images/l175201814303772.jpg"
    ],
    "video": ""
  },
  {
    "id": "teknolojinin-hayatimizdaki-yeri-ve-olculu-olmanin-onemi",
    "title": "“Teknolojinin Hayatımızdaki Yeri ve Ölçülü Olmanın Önemi”",
    "image": "/files/images/l1452018224422490.jpg",
    "description": "“Teknolojinin Hayatımızdaki Yeri ve Ölçülü Olmanın Önemi”Hayatımızın olmazsa olmaz bir parçası haline gelmiş teknolojinin, kültürüne uygun kullanılması çok önemlidir. Ortaokul rehber öğretmenimiz “Teknolojinin Hayatımızdaki Yeri ve Ölçülü Olmanın Önemi” içerikli sunumunu ortaokul öğrencilerimizle paylaşarak onların bu konuda daha bilinçli hale gelmelerini desteklemiştir. Öğrencilerimizin aktif katılımıyla sunumumuz keyifle tamamlanmıştır.",
    "gallery": [
      "/files/images/l1452018224422490.jpg",
      "/files/images/l1452018224422599.jpg",
      "/files/images/l1452018224422724.jpg",
      "/files/images/l1452018224422818.jpg"
    ],
    "video": ""
  },
  {
    "id": "poster-contest",
    "title": "Poster Contest",
    "image": "/files/images/l1452018133031673.jpg",
    "description": "Poster ContestMovie Poster Winner Announcement!!!Our grade 5 and 6 students worked hard for three weeks to write up their movie reports and design beautiful posters.  The judging team spent quite a bit of time choosing the winning posters after collecting all the entries.Friday came around and we were able to award the following students with certificates and a promise of a field trip to the movie theater in the near future.  The winners of this competition are:Grade 5 winners, in no particular order:*Elif Yavrutürk   *Adin Koylan  *Hatice Naz Solak  *Beyza Ertan  *Emre Civcik*Demir Halisdemir  *Havin Memiş  *Duru Özdoğan  * Ahmet Atilla KarakayaGrade 6 winners, in no particular order:*Duru Balcılar  *Hasan Yozgat  *Ada Güler  *Kıvanç Güven",
    "gallery": [
      "/files/images/l1452018133031673.jpg",
      "/files/images/l1452018132735265.jpg",
      "/files/images/l1452018132735453.jpg",
      "/files/images/l1452018132735593.jpg",
      "/files/images/l1452018132735718.jpg",
      "/files/images/l1452018132735875.jpg",
      "/files/images/l14520181328350.jpg",
      "/files/images/l1452018132835156.jpg",
      "/files/images/l1452018132835297.jpg",
      "/files/images/l1452018132835437.jpg",
      "/files/images/l1452018132835593.jpg",
      "/files/images/l1452018132835750.jpg",
      "/files/images/l1452018132835906.jpg",
      "/files/images/l145201813293562.jpg",
      "/files/images/l1452018132935234.jpg"
    ],
    "video": ""
  },
  {
    "id": "teog-kampi",
    "title": "TEOG Kampı",
    "image": "/files/images/l125201811129469.jpg",
    "description": "TEOG Kampı",
    "gallery": [
      "/files/images/l125201811129469.jpg",
      "/files/images/l125201811129562.jpg",
      "/files/images/l125201811129703.jpg",
      "/files/images/l125201811129844.jpg",
      "/files/images/l125201811129953.jpg",
      "/files/images/l12520181113994.jpg",
      "/files/images/l125201811139250.jpg",
      "/files/images/l125201811139391.jpg"
    ],
    "video": ""
  },
  {
    "id": "quiz-show",
    "title": "QUIZ SHOW",
    "image": "/files/images/l952018102948940.jpg",
    "description": "QUIZ SHOWPERFECTLY OUTSTANDING!!!!The four teams that worked together to gather points towards becoming QUIZ SHOW CHAMPIONS were inspiring.  Great teamwork and knowledge were put to the test for two full hours of nail-biting entertainment.At the end of such a close competition the winners are YAĞMUR EKİZ, BARIŞ SAYGI, BORA CEYLAN AND SARP CİN.Thanks and congratulations to all who took the stage today!",
    "gallery": [
      "/files/images/l952018102948940.jpg",
      "/files/images/l952018103048471.jpg",
      "/files/images/l95201810314818.jpg"
    ],
    "video": ""
  },
  {
    "id": "readasaurs-3-winner-at-gelisim-private-schools",
    "title": "READASAURS 3 WINNER AT GELİŞİM PRIVATE SCHOOLS",
    "image": "/files/images/l952018102245769.JPG",
    "description": "READASAURS 3 WINNER AT GELİŞİM PRIVATE SCHOOLSLast Friday we had a very special visitor come and talk with our grade 5 and 6 classes.  Sam chit-chatted with us about how much fun reading can be.But of course he didn't come empty handed.  Sam also brought along a prize to present to this year's 3rd PLACE WINNER in the READASAURS 3 video competition, our very own AHMET ATİLLA KARAKAYA.Thank you, Sam, for coming and congratulations again to Atilla and to all our students who entered videos in this contest.  We hope to have even more entries and even more winners next year.",
    "gallery": [
      "/files/images/l952018102245769.JPG",
      "/files/images/l952018102345770.JPG",
      "/files/images/l952018102445113.JPG",
      "/files/images/l952018102445457.JPG"
    ],
    "video": ""
  },
  {
    "id": "fen-bilimleri-proje-sergisi",
    "title": "Fen Bilimleri Proje Sergisi",
    "image": "/files/images/l452018179297.jpg",
    "description": "Fen Bilimleri Proje Sergisi2 Mayıs Çarşamba günü 5, 6 ve 7. sınıf öğrencileri fen bilimleri dersi kapsamında yapmış oldukları projeleri sergilediler.  Her yıl olduğu gibi bu yılda yaratıcı ve özgün fikirler ile projelerini sunan öğrenciler birbirleriyle verimli paylaşımlarda bulundular.",
    "gallery": [
      "/files/images/l452018179297.jpg",
      "/files/images/l45201817929101.jpg",
      "/files/images/l45201817929179.jpg",
      "/files/images/l45201817929319.jpg",
      "/files/images/l45201817929413.jpg",
      "/files/images/l45201817929507.jpg",
      "/files/images/l45201817929601.jpg",
      "/files/images/l45201817929679.jpg",
      "/files/images/l45201817929772.jpg",
      "/files/images/l45201817929866.jpg",
      "/files/images/l45201817929944.jpg",
      "/files/images/l45201817102938.jpg",
      "/files/images/l452018171029116.jpg",
      "/files/images/l452018171029194.jpg",
      "/files/images/l452018171029288.jpg",
      "/files/images/l452018171029382.jpg",
      "/files/images/l452018171029491.jpg"
    ],
    "video": ""
  },
  {
    "id": "grade-5-spelling-bee",
    "title": "GRADE 5 SPELLING BEE",
    "image": "/files/images/l452018175019447.JPG",
    "description": "GRADE 5 SPELLING BEEOrtaokul beşinci sınıf öğrencileri arasında düzenlenen \"Spelling Bee\" adlı heceleme yarışmasında birbirlerine karşı yarıştı. Çekişmeli geçen mücadele sonucu dereceye giren öğrenciler sinema bileti ödülünü kazandılar.We spent an exciting afternoon watching our grade five students compete in our annual SPELLING BEE.   Round by round the group of over 20 competitors shrank until we had our three finalists.  With the grade four classes watching we were able to announce this year's three  SPELLING BEE champions.This year's SPELLING BEE hourors went to EFE AHMETLER, DAMLA YELİZ BAKIR and KIVANÇ GÜVEN.The winners of the 2016-2017 Grade 5 Spelling Bee spelling competition were presented with certificates and a ticket each to see Moana in the movie theater.Congratulations to all the contestants and best wishes for next time!",
    "gallery": [
      "/files/images/l2132017103120689.jpg",
      "/files/images/l2132017103120861.jpg",
      "/files/images/l21320171032202.jpg",
      "/files/images/l2132017103220174.jpg"
    ],
    "video": ""
  },
  {
    "id": "719-yas-aile-egitimi-ortaokul-1-etap",
    "title": "7-19 YAŞ AİLE EĞİTİMİ ORTAOKUL 1. ETAP",
    "image": "/files/images/l242018233136964.jpg",
    "description": "7-19 YAŞ AİLE EĞİTİMİ ORTAOKUL 1. ETAP1. OTURUM “ERGENİ TANIMAK”BU OTURUMUN GENEL AMAÇLARIBu oturumu tamamlayan katılımcılarımız,-Ergenlik dönemindeki gelişim alanlarını tanırlar.-Ergenlik dönemindeki değişimleri fark ederler.-Ergenlik döneminde hem çocuklara hem de yakın çevresine nasıl destek olabileceklerinin farkına varırlar.-Ergenlik döneminde gelişim dönemlerini desteklemeye yönelik bilgi ve beceriler kazanırlar.-Velilerimizin yoğun katılımıyla, paylaşıma dayalı bir ortamda, etkinliklerimizle zenginleştirilen oturumumuz keyifli ve verimli bir şekilde tamamlanmıştır.7-19 YAŞ AİLE EĞİTİMİ 2. OTURUM “İLETİŞİM KURMAK”BU OTURUMUN GENEL AMAÇLARIBu oturumu tamamlayan katılımcılarımız,-İletişimle ilgili temel bilgiler edinirler.-İletişimde zamanı etkin olarak düzenleyebilirler.-Ergen çocuklarına yönelik kullanabilecekleri iletişim becerilerini geliştirirler.-İlk oturumumuzla bağlantılı olarak yürüttüğümüz bu oturumda, oluşan enerji  grup dinamiğimizin de etkisiyle, eğlenceli etkinliklerimizle farkındalık dolu bir oturum tamamladık.7-19 YAŞ AİLE EĞİTİMİ 3. OTURUM “BİRLİKTE BÜYÜMEK”BU OTURUMUN GENEL AMAÇLARIBu oturumu tamamlayan katılımcılarımız,-Anne baba ve eş olarak aile içindeki rollerinin farkına varırlar.-Sağlıklı bir ilişki için gerekli becerileri kazanırlar.Aile yaşam döngülerimizin bir süreç olup, her ailenin zamanla büyüyüp, farklılaşıp geliştiğini ve ilişkilerimizdeki temel ihtiyaçlarımızı göz ardı etmeden bu süreci tamamlamanın önemini konuşarak sağlıklı aile gelişimi için paylaşımda bulunduk.7-19 YAŞ AİLE EĞİTİMİ 4. OTURUM “ANNE-BABA TUTUTMLARI”BU OTURUMUN GENEL AMAÇLARIBu oturumu tamamlayan katılımcılarımız-Aile içi farklı tutumların kendileri ve çocuk­ları üzerindeki etkisinin farkında olurlar.-Sağlıklı bir ilişki için yetkin tutum becerisi geliştirirler.Birinci grubumuzun son oturumu olan “Anne-Baba Tutumları” nı velilerimizin yoğun katılımıyla tamamladık. İçeriğin verimli işlenmesinin yanı sıra oluşan grup dinamiği ve anne babaların paylaşım dolu kurdukları güçlü ilişkiler bizleri çok mutlu etti. Siz velilerimizle başka eğitimlerde buluşmak üzere…",
    "gallery": [
      "/files/images/l242018233136964.jpg",
      "/files/images/l242018233236167.jpg",
      "/files/images/l242018233236354.jpg",
      "/files/images/l242018233236557.jpg",
      "/files/images/l242018233236761.jpg",
      "/files/images/l242018233236995.jpg",
      "/files/images/l242018233336198.jpg",
      "/files/images/l242018233336417.jpg",
      "/files/images/l242018233336620.jpg",
      "/files/images/l942018135040670.jpg",
      "/files/images/l942018135040873.jpg",
      "/files/images/l94201813514076.jpg",
      "/files/images/l942018135140311.jpg",
      "/files/images/l942018135140514.jpg",
      "/files/images/l942018135140717.jpg",
      "/files/images/l942018135140904.jpg",
      "/files/images/l942018135240108.jpg",
      "/files/images/l942018135240311.jpg"
    ],
    "video": "https://www.youtube.com/embed/CNSpOyn7zc4?ecver=1"
  },
  {
    "id": "masa-tenisi-sampiyonlugu",
    "title": "Masa Tenisi Şampiyonluğu",
    "image": "/files/images/l2632018101030130.jpg",
    "description": "Masa Tenisi ŞampiyonluğuMersin Gençlik ve Spor İl Müdürlüğü”nün düzenlediği “Okullar Arası Küçük Erkek Masa Tenisi Müsabakaları İl Birinciliği Grup Maçları ” nda Özel Güney Gelişim Okulları Küçük Erkek Masa Tenisi Takımımız birinci olmuştur.Gururlandıran öğrencilerimizi ve öğretmenimizi kutluyor, başarılarının devamını diliyoruz.",
    "gallery": [
      "/files/images/l2632018101030130.jpg",
      "/files/images/l2632018101030396.jpg",
      "/files/images/l2632018101030536.jpg"
    ],
    "video": ""
  },
  {
    "id": "kodlamarobotik-veli-atolyesi",
    "title": "Kodlama-Robotik Veli Atölyesi",
    "image": "/files/images/l26320181145493.jpg",
    "description": "Kodlama-Robotik Veli Atölyesi24 Mart Cumartesi günü 5. Sınıf öğrencilerimizin ve velilerimizin katıldığı \"Kodlama-Robotik Veli Atölyesi\" etkinliğini gerçekleştirdik. Lego Education WeDO setlerini kullandığımız etkinlikte öğrencilerimiz tasarladıkları robotları harekete geçirdiler.",
    "gallery": [
      "/files/images/l26320181145493.jpg",
      "/files/images/l2632018115524.jpg",
      "/files/images/l26320181155571.jpg",
      "/files/images/l26320181165118.jpg"
    ],
    "video": "https://www.youtube.com/embed/CByqUXUoPV0?ecver=1"
  },
  {
    "id": "yildiz-erkekler-tenis-turnuvasi-sampiyonlugu",
    "title": "Yıldız Erkekler Tenis Turnuvası Şampiyonluğu",
    "image": "/files/images/l143201813346572.jpg",
    "description": "Yıldız Erkekler Tenis Turnuvası ŞampiyonluğuOkul sporları kapsamında düzenlenen Yıldız Erkekler Tenis Turnuvasında takımımız Mersin 1.'si olmuştur.Okul sporları kapsamında düzenlenen Küçük Erkekler Tenis Turnuvasında takımımız Mersin 2.'si olmuştur.",
    "gallery": [
      "/files/images/l143201813346572.jpg",
      "/files/images/l14320181388494.jpg"
    ],
    "video": ""
  },
  {
    "id": "yildiz-kiz-voleybol-musabakalari",
    "title": "Yıldız Kız Voleybol Müsabakaları",
    "image": "/files/images/l1132018132329640.jpg",
    "description": "Yıldız Kız Voleybol MüsabakalarıMersin de Düzenlenen Okullar Arası Yıldız Kız Voleybol Müsabakalarında Okul Takımımız Mersin 2.si Olmuştur. Takımımızı Tebrik Eder Grup Maçlarında  Başarılar Dileriz.",
    "gallery": [
      "/files/images/l1132018132329640.jpg",
      "/files/images/l1132018132329718.JPG",
      "/files/images/l1132018132429671.JPG",
      "/files/images/l1132018132529687.JPG",
      "/files/images/l1132018132629687.JPG",
      "/files/images/l1132018132729640.JPG",
      "/files/images/l1132018132829609.JPG",
      "/files/images/l1132018132929546.JPG",
      "/files/images/l1132018133029515.JPG",
      "/files/images/l1132018133129515.JPG",
      "/files/images/l1132018133229546.JPG",
      "/files/images/l1132018133329578.JPG",
      "/files/images/l1132018133429531.JPG",
      "/files/images/l1132018133529484.JPG",
      "/files/images/l1132018133629437.JPG",
      "/files/images/l1132018133729359.JPG",
      "/files/images/l1132018133829312.png"
    ],
    "video": ""
  },
  {
    "id": "yildiz-voleybol-kiz-takimimiz-yari-finalde",
    "title": "Yıldız Voleybol Kız Takımımız Yarı Finalde",
    "image": "/files/images/l532018132333623.jpg",
    "description": "Yıldız Voleybol Kız Takımımız Yarı FinaldeTakımımız grubundaki bütün maçlarını kazanarak yarı finale yükseldi. Takımımızı kutluyor ve başarılarının devamını diliyoruz.",
    "gallery": [
      "/files/images/l532018132333623.jpg",
      "/files/images/l532018132333779.jpg",
      "/files/images/l532018132333888.jpg",
      "/files/images/l53201813243313.jpg",
      "/files/images/l532018132433123.jpg"
    ],
    "video": ""
  },
  {
    "id": "okulumuzun-yildiz-kiz-voleybol-takimi-ceyrek-finalde",
    "title": "Okulumuzun Yıldız Kız Voleybol Takımı Çeyrek Finalde...",
    "image": "/files/images/l2622018172553169.jpg",
    "description": "Okulumuzun Yıldız Kız Voleybol Takımı Çeyrek Finalde...",
    "gallery": [
      "/files/images/l2622018172553169.jpg"
    ],
    "video": ""
  },
  {
    "id": "close-count-game",
    "title": "CLOSE COUNT GAME",
    "image": "/files/images/l2622018135644307.jpg",
    "description": "CLOSE COUNT GAMEAnother term coming to a close brings the announcement of the first semester CLOSE COUNT GAME WINNERS.By guessing correctly most frequently these four students really put in some effort to win.We're proud to congratulate MAYA ASENA KARAKAYA, AHMET ATİLLA KARAKAYA, ELİS BUDUR and NAZ KURTULUŞ of the students body for being on target so often!And we thank our maths teacher MUŞERREF DİLSEL from the teaching staff for playing along as well.This terms prizes were movie tickets for each studentto view a film of their choice.CLOSE COUNT resumes the first day of second term.Good luck!!!Birinci dönemin sonuna doğru Close Count Game'in (Yakın Tahmin Oyunu) kazananları belli oldu. En sık yakın tahminde bulunan 4 öğrencimiz dönem boyunca bunun için çok çaba harcadılar. Bu harcadıkları çaba için Maya Asena Karakaya, Ahmet Atilla Karakaya, Elis Budur ve Naz Kurtuluş'u tebrik ediyoruz. Ayrıca Matematik Öğretmenimiz Müşerref Dilsel'e de öğrencilerimizle birlikte oyuna dahil olduğu için teşekkür ediyoruz.Bu etkinliğin ödülü olarak öğrencilerimize gitmek istedikleri sinema için birer sinema bileti verildi.Yarışmamız 2. dönemin ilk günü itibariyle kaldığı yerden devam edecek.Herkese iyi şanslar!",
    "gallery": [
      "/files/images/l2622018135644307.jpg"
    ],
    "video": ""
  },
  {
    "id": "mersin-okul-sporlari-satranc-yarismasi",
    "title": "MERSİN OKUL SPORLARI SATRANÇ YARIŞMASI",
    "image": "/files/images/l2022018114552765.jpg",
    "description": "MERSİN OKUL SPORLARI SATRANÇ YARIŞMASI2017-2018 Mersin Okul Sporları Satranç Yarışmaları 17-18 Şubat tarihlerinde oynandı. Toplamda 99 takımın mücadele ettiği turnuvaya 3 kategoride 7 takımla katıldık.Dereceğe giren takımlarımız ve oyuncuları;1) Küçükler Genel Kategorisinde 1. olan takımımız-Sarp YILMAZ-Hasan YOZGAT-Aydın Altar GÜVENOĞLU-İlker ÖZEL1. olan Ortaokul takımımız Okul Sporları Bölge Finallerinde Mersin'i ve Okulumuzu temsil etmeye hak kazanmışlardır.Katılan sporcularımızı tebrik ediyoruz ve başarılarının devamını diliyoruz.",
    "gallery": [
      "/files/images/l2022018114552765.jpg"
    ],
    "video": ""
  },
  {
    "id": "corn-flake-treats",
    "title": "CORN FLAKE TREATS!",
    "image": "/files/images/l15122017162656937.jpg",
    "description": "CORN FLAKE TREATS!Just as the weather is cooling off ENGLISH CLUB is heating up! This week we really got creative and cooked up a batch ofCORN FLAKE TREATS! Reading a simple recipe, counting out measurements and decorating our creations was great fun. You can enjoy these yummy treats as well by following the recipe provided here.....Enjoy!Bu hafta İngilizce klüp etkinliğimizde 'Corn Flake Treats' hazırladık ve afiyetle yedik. Tarifimiz ile hem lezzetli atıştırmalıklar yapmayı öğrendik hem de eğlenceli vakit geçirdik.Siz de bu keyifli atıştırmalıklardan tatmak isterseniz, tarifi mutlaka denemenizi öneriyoruz. Afiyet olsun!",
    "gallery": [
      "/files/images/l15122017162656937.jpg",
      "/files/images/l15122017162756359.jpg",
      "/files/images/l15122017162756781.jpg",
      "/files/images/l15122017162856562.jpg",
      "/files/images/l15122017162956406.jpg"
    ],
    "video": ""
  },
  {
    "id": "arkadaslik-haftasi-4-gun",
    "title": "ARKADAŞLIK HAFTASI 4. GÜN",
    "image": "/files/images/l14122017234710718.jpg",
    "description": "ARKADAŞLIK HAFTASI 4. GÜNGüney Gelişim Ortaokulu olarak \"Arkadaşlık Haftası'nın\" 4.gününde  \"WALL-E \" adlı arkadaşlık temalı  animasyon filmini öğrencilerimizle beraber izledik. Animasyon filmi empati, sevgi, hoşgörü, doğaya saygı, zorbalıktan uzak, doğru bir iletişim yöntemi ile her türlü sorunu çözebileceğimiz mesajını bize verirkenöğrencilerimiz filimden son derece keyif aldılar. Beraber film izlemenin mutluluğunu da bir kez daha yaşamış oldular.",
    "gallery": [
      "/files/images/l14122017234710718.jpg",
      "/files/images/l14122017234710843.jpg",
      "/files/images/l14122017234710968.jpg"
    ],
    "video": ""
  },
  {
    "id": "arkadaslik-haftasi-3-gun",
    "title": "ARKADAŞLIK HAFTASI 3. GÜN",
    "image": "/files/images/l13122017175116285.jpg",
    "description": "ARKADAŞLIK HAFTASI 3. GÜNGüney Gelişim Koleji olarak \"Arkadaşlık Haftası'nın\" 3.gününde öğrencilerimiz bin bir emek, sevgiyle kitap ayıraçları ve anahtarlıklar yaparak birbirlerine hediye ettiler. Etkinliğimize öğretmenlerimiz de katıldı. Etkinliğimiz son derece keyifli geçerken, öğrencilerimizin  paylaşma, kollektif bilinç, arkadaşlık ve dayanışma duyguları bir kez daha pekişmiş oldu.",
    "gallery": [
      "/files/images/l13122017175116285.jpg",
      "/files/images/l13122017175116613.jpg",
      "/files/images/l13122017175116722.jpg",
      "/files/images/l13122017175116847.jpg",
      "/files/images/l13122017175116941.jpg",
      "/files/images/l1312201717521651.jpg",
      "/files/images/l13122017175216160.jpg",
      "/files/images/l13122017175216254.jpg",
      "/files/images/l13122017175216363.jpg",
      "/files/images/l13122017175216457.jpg",
      "/files/images/l13122017175216582.jpg",
      "/files/images/l13122017175216691.jpg",
      "/files/images/l13122017175216785.jpg",
      "/files/images/l13122017175216910.jpg",
      "/files/images/l1312201717531635.jpg",
      "/files/images/l13122017175316144.jpg",
      "/files/images/l13122017175316254.jpg",
      "/files/images/l13122017175316363.jpg",
      "/files/images/l13122017175316488.jpg",
      "/files/images/l13122017175316598.jpg",
      "/files/images/l13122017175316722.jpg",
      "/files/images/l13122017175316832.jpg",
      "/files/images/l13122017175316941.jpg",
      "/files/images/l1312201717541651.jpg",
      "/files/images/l13122017175416379.jpg",
      "/files/images/l13122017175416488.jpg",
      "/files/images/l13122017175416613.jpg",
      "/files/images/l13122017175416769.jpg",
      "/files/images/l13122017175416879.jpg",
      "/files/images/l1312201717551619.jpg",
      "/files/images/l13122017175516113.jpg",
      "/files/images/l13122017175516222.jpg",
      "/files/images/l13122017175516441.jpg",
      "/files/images/l13122017175516551.jpg",
      "/files/images/l13122017175516660.jpg",
      "/files/images/l13122017175516769.jpg",
      "/files/images/l13122017175516894.jpg",
      "/files/images/l131220171756164.jpg",
      "/files/images/l13122017175616113.jpg",
      "/files/images/l13122017175616222.jpg",
      "/files/images/l13122017175616332.jpg",
      "/files/images/l13122017175616457.jpg",
      "/files/images/l13122017175616582.jpg",
      "/files/images/l13122017175616691.jpg",
      "/files/images/l13122017175616816.jpg",
      "/files/images/l13122017175616910.jpg",
      "/files/images/l1312201717571619.jpg",
      "/files/images/l13122017175716144.jpg",
      "/files/images/l13122017175716238.jpg"
    ],
    "video": ""
  },
  {
    "id": "okulumuzun-mini-voleybol-takimi-sezona-galibiyetle-basladi",
    "title": "Okulumuzun Mini Voleybol Takımı Sezona Galibiyetle Başladı",
    "image": "/files/images/l13122017103916370.jpeg",
    "description": "Okulumuzun Mini Voleybol Takımı Sezona Galibiyetle BaşladıOkulumuzun Mini Voleybol Takımı Sezona Galibiyetle Başladı.",
    "gallery": [
      "/files/images/l13122017103916370.jpeg",
      "/files/images/l13122017103916526.jpeg"
    ],
    "video": ""
  },
  {
    "id": "arkadaslik-haftasi-2-gun",
    "title": "ARKADAŞLIK HAFTASI 2. GÜN",
    "image": "/files/images/l12122017221528242.jpg",
    "description": "ARKADAŞLIK HAFTASI 2. GÜNOkulumuz olarak belirlediğimiz Arkadaşlık Haftası'nın 2.gününde öğrencilerimiz  öğretmenlerimizin rehberliğinde  arkadaşlık bileklikleri yaparak birbirlerine hediye ettiler.Öğrencilerimizin yoğun bir ilgi ile katıldığı etkinliğimiz de son derece keyifli geçti.",
    "gallery": [
      "/files/images/l12122017221528242.jpg",
      "/files/images/l12122017221528352.jpg",
      "/files/images/l12122017221528571.jpg",
      "/files/images/l12122017221528664.jpg",
      "/files/images/l12122017221528774.jpg",
      "/files/images/l12122017221528883.jpg",
      "/files/images/l12122017221528977.jpg",
      "/files/images/l12122017221628211.jpg",
      "/files/images/l12122017221628305.jpg",
      "/files/images/l12122017221628508.jpg",
      "/files/images/l12122017221628711.jpg",
      "/files/images/l12122017221628930.jpg",
      "/files/images/l1212201722172824.jpg",
      "/files/images/l12122017221728149.jpg",
      "/files/images/l12122017221728242.jpg",
      "/files/images/l12122017221728383.jpg",
      "/files/images/l12122017221728492.jpg",
      "/files/images/l12122017221728602.jpg",
      "/files/images/l12122017221728711.jpg",
      "/files/images/l12122017221728821.jpg",
      "/files/images/l12122017221728914.jpg",
      "/files/images/l12122017221828133.jpg",
      "/files/images/l12122017221828336.jpg",
      "/files/images/l12122017221828446.jpg",
      "/files/images/l12122017221828539.jpg",
      "/files/images/l12122017221828758.jpg",
      "/files/images/l12122017221828867.jpg",
      "/files/images/l12122017221828977.jpg",
      "/files/images/l12122017221928305.jpg",
      "/files/images/l12122017221928633.jpg"
    ],
    "video": ""
  },
  {
    "id": "arkadaslik-haftasi",
    "title": "ARKADAŞLIK HAFTASI",
    "image": "/files/images/l11122017232222849.jpg",
    "description": "ARKADAŞLIK HAFTASIGelişim Koleji \"Arkadaşlık Haftası\" 11-15 Aralık tarihleri arasında kutlanıyor.\"Arkadaşlık Haftası\" bünyesinde rehberlik birimi tarafindan düzenlenen etkinliklerimiz bugün  öğrencilerimizin yoğun katılımıyla başlamıştır.",
    "gallery": [
      "/files/images/l11122017232222849.jpg",
      "/files/images/l111220172323225.jpg",
      "/files/images/l11122017232322130.jpg",
      "/files/images/l11122017232322349.jpg",
      "/files/images/l11122017232322489.jpg",
      "/files/images/l11122017232322630.jpg",
      "/files/images/l11122017232322771.jpg",
      "/files/images/l1112201723242221.jpg",
      "/files/images/l11122017232422146.jpg",
      "/files/images/l11122017232422271.jpg",
      "/files/images/l11122017232422474.jpg",
      "/files/images/l11122017232422599.jpg",
      "/files/images/l11122017232422724.jpg",
      "/files/images/l11122017232422849.jpg",
      "/files/images/l11122017232422989.jpg",
      "/files/images/l11122017232522114.jpg",
      "/files/images/l11122017232522239.jpg",
      "/files/images/l11122017232522333.jpg",
      "/files/images/l11122017232522458.jpg",
      "/files/images/l11122017232522583.jpg",
      "/files/images/l11122017232522708.jpg",
      "/files/images/l1112201723262236.jpg",
      "/files/images/l11122017232622193.jpg",
      "/files/images/l11122017232622318.jpg",
      "/files/images/l11122017232622536.jpg",
      "/files/images/l11122017232622661.jpg",
      "/files/images/l11122017232622771.jpg",
      "/files/images/l11122017232622911.jpg",
      "/files/images/l1112201723272237.jpg",
      "/files/images/l11122017232722271.jpg",
      "/files/images/l11122017232722414.jpg",
      "/files/images/l11122017232722526.jpg",
      "/files/images/l11122017232722646.jpg",
      "/files/images/l11122017232722849.jpg"
    ],
    "video": ""
  },
  {
    "id": "kitap-fuari",
    "title": "KİTAP FUARI",
    "image": "/files/images/l4122017191440457.jpg",
    "description": "KİTAP FUARIGüney-Gelişim Ortaokulu olarak 28 Kasım Salı günü 3.Mersin Cnr Kitap Fuarı'na katıldık.Öğrencilerimiz eşsiz güzelliktekikitaplarla buluştular.Keyifli anlar yaşayan öğrencilerimiz kendilerine okuma kitapları aldılar.Fuar etkinliğimizin sonunda öğrencilerimiz yeni aldıkları kitapları inceleyerek sınıflarında bir okuma saati gerçekleştirdiler.",
    "gallery": [
      "/files/images/l4122017191440457.jpg",
      "/files/images/l4122017191440551.jpg",
      "/files/images/l4122017191440660.jpg",
      "/files/images/l4122017191440785.jpg",
      "/files/images/l4122017191440925.jpg",
      "/files/images/l412201719154019.jpg",
      "/files/images/l4122017191540113.jpg",
      "/files/images/l4122017191540222.JPG",
      "/files/images/l4122017191640269.JPG",
      "/files/images/l4122017191740347.JPG",
      "/files/images/l4122017191840363.JPG",
      "/files/images/l4122017191940519.JPG",
      "/files/images/l4122017192040535.JPG",
      "/files/images/l4122017192140597.jpg"
    ],
    "video": ""
  },
  {
    "id": "arkeoloji-muzesi-gezisi",
    "title": "ARKEOLOJİ MÜZESİ GEZİSİ",
    "image": "/files/images/l4122017192236472.JPG",
    "description": "ARKEOLOJİ MÜZESİ GEZİSİOkulumuzun 5. sınıf öğrencileriyle birlikte Mersin Arkeoloji Müzesi'ne bir gezi düzenledik. İlk Çağ Uygarlıkları'ndan kalma eserleri inceledik ve öğrencilerimize tanıttık. İlk Çağ'dan kalma eserlerin insanlık tarihine olan katkıları konusunda öğrencilerimiz bilgi sahibi oldular. Tarih boyunca yakın çevremizde  ve bulunduğumuz bölgede yaşamış olan uygarlıklar ve devletlerin bıraktığı tarihi eserleri tanıdık ve tarihi eserleri koruma konusunda öğrencilerimize duyarlılık kazandırdık.",
    "gallery": [
      "/files/images/l4122017192236472.JPG",
      "/files/images/l4122017192336784.JPG",
      "/files/images/l412201719253697.JPG",
      "/files/images/l4122017192636425.JPG",
      "/files/images/l4122017192736816.JPG",
      "/files/images/l4122017192936144.JPG",
      "/files/images/l4122017193036456.JPG",
      "/files/images/l4122017193136738.JPG",
      "/files/images/l4122017193336113.JPG",
      "/files/images/l4122017193436441.JPG"
    ],
    "video": ""
  },
  {
    "id": "ataturk-haftasi",
    "title": "ATATÜRK HAFTASI",
    "image": "/files/images/l8112017194939503.jpg",
    "description": "ATATÜRK HAFTASIOkulumuzun 7. sınıf öğrencileri \"10 Kasım Atatürk Haftası\" dolayısıyla \"Atatürk\" konulu resim sergisi açmıştır.Atamızı andığımız bu haftada ATAmıza bağlılıklarını, resimleriyle gösteren öğrencilerimizi tebrik ediyoruz.",
    "gallery": [
      "/files/images/l8112017194939503.jpg",
      "/files/images/l8112017194939628.jpg",
      "/files/images/l8112017194939737.jpg",
      "/files/images/l8112017194939862.jpg",
      "/files/images/l8112017194939956.jpg",
      "/files/images/l811201719503966.jpg"
    ],
    "video": ""
  },
  {
    "id": "5-siniflarimizin-antalya-kampi",
    "title": "5. Sınıflarımızın Antalya Kampı",
    "image": "/images2/img2_files/logo.jpg",
    "description": "5. Sınıflarımızın Antalya Kampı2017-2018 Eğitim-Öğretim Yılı içerisinde her yıl 5. Sınıflara yönelik düzenlemiş olduğumuzAntalya-Side kampını 06-10 Kasım tarihleri arasında gerçekleştirdik.Öğrencilerimizin kamp süresi boyunca ailelerinden uzakta sorumluluk bilincini, gözlem yeteneklerini geliştirerek, arkadaşlarıyla uyumlu, paylaşımcı olmalarını sağlamak, sosyal çevre ile ilişkilerini güçlendirmek amaçlanmıştır.Ayrıca öğrencilerimizin “Aspendos, Side Antik Kent, Apollon Tapınağı, Alanya” gibi tarihi yerleri gezip, görerek tarihi şuurun toplumda yerleşmesini ve gelişmesini sağlayarak gelecek nesillere köprü olan kültürümüzün unutulmaması ideallerimizi gerçekleştirdik.Öğrencilerimiz ile gerçekleştirmiş olduğumuz “Titreyen Göl ve Manavgat Şelalesi” gezisinde öğrencilerimizin doğaya saygılı, ekolojiye bağlı bireyler olmasını sağlamak, ayrıca sanatın, spor etkinliklerinin, müzik ve dansın katkısıyla öğrencilerimizin sosyo-psikolojik gelişimine yardımcı olarak öğrencilerimizle eğlenceli, güzel vakit geçirdik. Kamp süresinde etütlerimiz bilgi yarışmamız ile öğrencilerimizin bilgilerini pekiştirmelerini sağladık.10 Kasım Cuma günü saat 09:05’te Ulu ÖnderimizMustafa Kemal Atatürk’ün 79. ölüm yıl dönümünü andık.Öğrencilerimiz mutlu, enerjik ve heyecanlı bir şekilde gezi sonunda aileleri ile buluştular.1. GÜN2. GÜN2. Gün Disko3. Gün4. Gün5. Gün",
    "gallery": [],
    "video": "https://www.youtube.com/embed/7HkXIpMpj9Q?ecver=1"
  },
  {
    "id": "kubizm-sergisi",
    "title": "Kübizm Sergisi",
    "image": "/files/images/l20102017142813780.jpg",
    "description": "Kübizm Sergisi5. Sınıf Kübizm Sergisinden Kareler...",
    "gallery": [
      "/files/images/l20102017142813780.jpg",
      "/files/images/l20102017142813952.jpg",
      "/files/images/l2010201714291362.jpg",
      "/files/images/l20102017142913187.jpg",
      "/files/images/l20102017143813734.jpg"
    ],
    "video": ""
  },
  {
    "id": "7-siniflar-trt-gezisi",
    "title": "7. Sınıflar TRT Gezisi",
    "image": "/files/images/l19102017133711719.jpg",
    "description": "7. Sınıflar TRT GezisiTRT Çukurova Bölge Radyosuna yaptığımız gezi ile iletişimin önemini ve iletişim hataları hakkında bilgi alarakcanlı radyo deneyimini yaşadık...",
    "gallery": [
      "/files/images/l19102017133711719.jpg",
      "/files/images/l19102017133811312.jpg",
      "/files/images/l19102017133811875.jpg",
      "/files/images/l19102017133911609.jpg"
    ],
    "video": ""
  },
  {
    "id": "6-sinif-fen-bilimleri-hucre-sergisi",
    "title": "6. SINIF FEN BİLİMLERİ HÜCRE SERGİSİ",
    "image": "/files/images/l10102017174113527.JPG",
    "description": "6. SINIF FEN BİLİMLERİ HÜCRE SERGİSİ6. sınıf öğrencilerimiz fen bilimleri ve bilim uygulamaları dersi çerçevesinde yaptıklarıHÜCREmodellemeleriniokulumuzun giriş katında sergilemişlerdir. Sergide mikroskop ile de hücre örneklerini incelemişlerdir. Sergiyi 4. , 5. , 7. ve 8. sınıf öğrencilerimizgezmiş ve hücre modellerini incelemişlerdir.",
    "gallery": [
      "/files/images/l10102017174113527.JPG",
      "/files/images/l10102017174113668.JPG",
      "/files/images/l10102017174113777.JPG",
      "/files/images/l10102017174113902.JPG",
      "/files/images/l1010201717421312.JPG"
    ],
    "video": ""
  },
  {
    "id": "20162017-u12--mersin-sampiyonu",
    "title": "2016-2017 U12  Mersin Şampiyonu",
    "image": "/files/images/l2492017231920634.jpeg",
    "description": "2016-2017 U12  Mersin ŞampiyonuTakımımız2016-2017 Basketbol Sezonu U12 Mersin Şampiyonuolmuştur.Takımımızı tebrik eder başarılarının devamını dileriz.",
    "gallery": [
      "/files/images/l2492017231920634.jpeg",
      "/files/images/l2492017231920728.jpeg",
      "/files/images/l2492017231920806.jpeg",
      "/files/images/l910201713235772.JPG",
      "/files/images/l910201713245772.JPG"
    ],
    "video": ""
  },
  {
    "id": "jrnba-ligi",
    "title": "JRNBA Ligi",
    "image": "/files/images/l2492017232014105.jpeg",
    "description": "JRNBA LigiÖğrencilerimiz Türkiye Basketbol Fedarasyonu ve NBA işbirliği ile düzenlenen JRNBA ligiturnuvasına katılarak başarı belgesi almışlardır. Takımlarımızın başarılarının devamını dileriz.",
    "gallery": [
      "/files/images/l2492017232014105.jpeg",
      "/files/images/l9102017132955869.JPG"
    ],
    "video": ""
  },
  {
    "id": "teog-sonuclari",
    "title": "Teog Sonuçları",
    "image": "/files/images/l1082017191843827.jpg",
    "description": "Teog Sonuçları",
    "gallery": [
      "http://www.guneygelisim.k12.tr/files/images/c1082017192943437.jpg.jpg",
      "/files/images/l1082017191843827.jpg"
    ],
    "video": ""
  },
  {
    "id": "tiyatro-gosterisi",
    "title": "Tiyatro Gösterisi",
    "image": "/files/images/l2652017134949948.JPG",
    "description": "Tiyatro GösterisiOrtaokul öğrencilerimizin büyük bir emek ve özveriye çalışıp hazırladıkları Haldun Taner'in \"Gözlerimi Kaparım Vazifem Yaparım \" adlı tiyatrosu 22 Mayıs pazartesi günü sahneye konuldu. İki saate yakın süren bu tiyatroyu velilerimiz ve öğrencilerimiz büyük bir ilgiye izlediler. Böylesine üst düzey bir tiyatroyu sahnelemede gözterdikleri başarı için öğrencilerimizi tebrik ediyoruz. Emeği geçen öğretmenlerimizede teşekkür ediyoruz.",
    "gallery": [
      "/files/images/l2652017134949948.JPG",
      "/files/images/l2652017135249291.JPG",
      "/files/images/l2652017135449463.JPG",
      "/files/images/l2652017135649807.JPG",
      "/files/images/l2652017135849869.JPG",
      "/files/images/l265201713050572.JPG",
      "/files/images/l265201713350166.JPG",
      "/files/images/l265201713450744.JPG",
      "/files/images/l265201713650604.JPG",
      "/files/images/l265201713850947.JPG",
      "/files/images/l265201713115072.JPG",
      "/files/images/l265201713135072.JPG",
      "/files/images/l2652017131450932.JPG",
      "/files/images/l2652017131750166.JPG",
      "/files/images/l2652017131950900.JPG",
      "/files/images/l2652017132150869.JPG",
      "/files/images/l2652017132350479.JPG",
      "/files/images/l2652017132450916.JPG",
      "/files/images/l2652017132650900.JPG",
      "/files/images/l2652017132950760.JPG",
      "/files/images/l2652017133150650.JPG",
      "/files/images/l2652017133450213.JPG",
      "/files/images/l2652017133550854.JPG",
      "/files/images/l2652017133750572.JPG",
      "/files/images/l2652017133950401.JPG",
      "/files/images/l2652017134150432.JPG"
    ],
    "video": "https://www.youtube.com/embed/vouM11_4D2Y?ecver=1"
  },
  {
    "id": "-muzik-festivali-",
    "title": " Müzik Festivali ",
    "image": "/files/images/l12520172383273.jpg",
    "description": "Müzik FestivaliSene başından itibaren azimle çalışan koromuz \"Mersin Müzik Festivali \" kapsamında yapılan 18. Nevit KODALLI  çok sesli korolar şenliğinde performanslarını sahneledi.Yüreklere işleyen sesleriyle gözleri dolduran şarkılar ve türküler söyleyen koromuzun piyano eşliklerini de öğrencilerimiz yaptı. Sizlerle gurur duyuyoruz. Tebrik ediyor,başarılarınızın devamını diliyoruz.",
    "gallery": [
      "/files/images/l12520172383273.jpg",
      "/files/images/l12520172383523.jpg"
    ],
    "video": ""
  },
  {
    "id": "6-siniflarimiz-uzay-kampinda",
    "title": "6. Sınıflarımız Uzay Kampında",
    "image": "/files/images/l952017154246945.jpg",
    "description": "6. Sınıflarımız Uzay Kampında5-7 Mayıs tarihleri arasında 6. sınıflarımızdan bir grup öğrencilerimiz İzmir Uzay Kampı'nda \" Yıldızlar ve Gezegenler Macerası \" programına  katıldılar.Uzay ve Uzay teknolojileri hakkında birçok bilgi edinen öğrencilerimiz, birbirinden eğlenceli deneyimlerle dolu günler geçirdiler.",
    "gallery": [
      "/files/images/l952017154246945.jpg",
      "/files/images/l952017154346320.jpg",
      "/files/images/l952017154346617.jpg",
      "/files/images/l952017154346820.jpg",
      "/files/images/l952017154346961.jpg",
      "/files/images/l952017154446101.jpg",
      "/files/images/l952017154446242.jpg"
    ],
    "video": ""
  },
  {
    "id": "6-siniflar-quiz-show-ingilizce--almanca",
    "title": "6. Sınıflar Quiz Show (İngilizce - Almanca)",
    "image": "/files/images/l25420179624358.jpg",
    "description": "6. Sınıflar Quiz Show (İngilizce - Almanca)Once again we have a great time watching our students compete in our yearly English and German Quiz Show.  Volunteers from our grade 6 classes worked in teams to answer questions regarding English grammer, world cultures and general knowledge in both languages.  The audience, made up of our grades 4, 5, 6 and 7 students, had fun playing along all afternoon.We congratulate each and every one of our contestants and celebrate the win for the Tasmanian Devils Team made up of Fehiman Demirçelik, Göksu Öz, Kenan Can peker and Naz Kurtuluş!Her sene yaptığımız İngilizce ve Almanca Quiz Show yarışmasını izlerken bu yıl da yine harika vakit geçirdik. Okulumuz 6. sınıf öğrencilerinden gönüllü olanlar İngilizce dil bilgisi, dünya kültürleri ve genel kültür sorularını yanıtlamak için takımlar halinde yarıştılar. Okulumuz 4., 5., 6. ve 7. sınıf öğrencileri de izleyici olarak çok keyifli vakit geçirdiler.Yarışmamıza katılan tüm öğrencileri kutluyoruz ve kazananTasmanian Devils takımından Fehiman Demirçelik, Eren Göksu Öz, Kenan Can Peker ve Naz Kurtuluş'u tebrik ediyoruz.",
    "gallery": [
      "/files/images/l25420179624358.jpg",
      "/files/images/l25420179624639.JPG",
      "/files/images/l25420179624999.JPG",
      "/files/images/l25420179724327.jpg",
      "/files/images/l25420179724577.jpg",
      "/files/images/l25420179724780.JPG",
      "/files/images/l25420179824140.jpg",
      "/files/images/l25420179824499.jpg",
      "/files/images/l2552017103816137.jpeg"
    ],
    "video": ""
  },
  {
    "id": "kisisel-resim-sergisi--kursat-ruzgar-yelin",
    "title": "Kişisel resim sergisi  Kürşat Rüzgar Yelin",
    "image": "/files/images/l2042017151335211.jpg",
    "description": "Kişisel resim sergisi  Kürşat Rüzgar YelinOrtaokul 5. Sınıf öğrencimizin hazırlamış olduğu \"Ben Goya'yım\" konulu kişisel resim sergisi.",
    "gallery": [
      "/files/images/l2042017151335211.jpg",
      "/files/images/l2042017151335352.jpg",
      "/files/images/l2042017151335477.jpg",
      "/files/images/l2042017151335602.jpg",
      "/files/images/l2042017151335727.jpg",
      "/files/images/l2042017151335821.jpg",
      "/files/images/l2042017151335930.jpg",
      "/files/images/l204201715143555.jpg",
      "/files/images/l2042017151435180.jpg",
      "/files/images/l2042017151435289.jpg",
      "/files/images/l2042017151435446.jpg",
      "/files/images/l2042017151435586.jpg",
      "/files/images/l2042017151435727.jpg",
      "/files/images/l2042017151435852.jpg",
      "/files/images/l20420171515358.jpg",
      "/files/images/l2042017151535118.jpg"
    ],
    "video": ""
  },
  {
    "id": "resim-sergisi",
    "title": "Resim Sergisi",
    "image": "/files/images/l1142017153855542.jpg",
    "description": "Resim SergisiOrtaokul 5. Sınıf öğrencimizin hazırlamış olduğu \"Ben Goya'yım\" konulu kişisel resim sergisinde buluşalım.",
    "gallery": [
      "/files/images/l1142017153855542.jpg"
    ],
    "video": ""
  },
  {
    "id": "-kucuk-kiz-yuzme-kategorisinde-ogrencimizin-basarisi",
    "title": " Küçük Kız Yüzme kategorisinde öğrencimizin başarısı",
    "image": "/files/images/l2232017125736940.jpg",
    "description": "Küçük Kız Yüzme kategorisinde öğrencimizin başarısıYüzme Küçük Kız kategorisinde öğrencimiz Şira Nur Eroglu 50m ve100m sırtüstü 50m serbest 200m karışıkta tüm rakiplerini açık ara farkla geçerek Mersin 1.si olmuştur. Öğrencimizi tebrik ediyoruz başarısının devamını diliyoruz.",
    "gallery": [
      "/files/images/l2232017125736940.jpg"
    ],
    "video": ""
  },
  {
    "id": "ogrencimiz-berkay-zantur-un-hazirlamis-oldugu-fotograf-sergimizi-actik-",
    "title": "Öğrencimiz Berkay Zantur un hazırlamış olduğu fotoğraf sergimizi açtık. ",
    "image": "/files/images/l213201715195945.JPG",
    "description": "Öğrencimiz Berkay Zantur un hazırlamış olduğu fotoğraf sergimizi açtık.Öğrencimiz Berkay Zantur'un hazırlamış olduğu fotoğraf sergimizi açtık. Öğrencimizin Sanata ve Doğaya olan sevgisini kutluyor, başarılarının devamını diliyoruz.",
    "gallery": [
      "/files/images/l213201715195945.JPG",
      "/files/images/l213201715215617.JPG",
      "/files/images/l213201715235633.JPG",
      "/files/images/l213201715255164.JPG",
      "/files/images/l213201715275383.JPG"
    ],
    "video": ""
  },
  {
    "id": "cambridge-certificate-ceremony",
    "title": "CAMBRIDGE CERTIFICATE CEREMONY",
    "image": "/files/images/l2132017103126364.jpg",
    "description": "CAMBRIDGE CERTIFICATE CEREMONYCAMBRIDGE EXAMSWe were proud to present certificates to each and every one of our students who took a Cambridge Proficiency Exam last year.  Students sat the STARTERS, MOVERS, FLYERS, and KET exams and were all awarded high marks for their efforts.CONGRATULATIONS WITH WISHES FOR CONTINUED SUCCESS,CAMBRIDGE PROFICIENCY SINAVI2016  yılında yapılan Cambridge yeterlik sınavına giren tüm öğrencilerimize katılım belgelerini sunduk. Öğrencilerimiz STARTERS, MOVERS, FLYERS VE KET sınavlarına girmiş olup, çalışmalarının karşılığı olan yüksek notlar alarak sertifikalarına hak kazanmışlardır.",
    "gallery": [
      "/files/images/l2132017103126364.jpg",
      "/files/images/l213201710322650.jpg"
    ],
    "video": ""
  },
  {
    "id": "close-count-awards",
    "title": "CLOSE COUNT AWARDS",
    "image": "/files/images/l2132017104324549.jpg",
    "description": "CLOSE COUNT AWARDSCLOSE COUNTBeginning on the first day of the new school year a new numbers game has been played by any student who wants to take a stab at the answer.  CLOSE COUNT questions are posted for students to guess at the answer each morning.  The answers are revealed each following morning.  All guesses are entered into a locked box.  The answers are checked and counted and winners are named on the basis of the closest guess to the correct answer.The first term winners of CLOSE COUNT were winners multiple times throughout the term.Awards went to MAYA ASENA KARAKAYA, YAĞMUR ADA CIVCIK and ELİS BUDUR for being the most frequent CLOSE COUNT winners throughout the first term.CLOSE COUNT questions continue to be posted each morning and we are excited to see the winners for this year's second term.CLOSE COUNTBu yıl okulun ilk gününden itibaren şansını denemek isteyen öğrenciler için yeni bir sayı oyunu başlatıldı. CLOSE COUNT soruları öğrencilerin tahminlerini yapmaları için her sabah panoya asılır ve öğrenciler tahminlerini kilitli bir kutuya atarlar. Tüm tahminler kontrol edildikten sonra, doğru cevaba en yakın tahmin o günün kazananı olur ve ertesi sabah ilan edilir. Birinci dönemin CLOSE COUNT şampiyonları dönem boyunca çok kez gün birincisi olan öğrencilerimiz Maya Asena Karakaya, Yağmur Ada Civcik ve Elis Budur olmuşlar ve ödüllerini teslim almışlardır.CLOSE COUNT soruları ikinci dönem de yayınlanmaya devam edecek olup, bu dönemin birincilerini merakle beklemekteyiz.",
    "gallery": [
      "/files/images/l2132017104324549.jpg"
    ],
    "video": ""
  },
  {
    "id": "crepe-party",
    "title": "CREPE PARTY",
    "image": "/files/images/l2132017104922377.jpg",
    "description": "CREPE PARTYCREPE AND PANCAKE PARTYThe grade 5 classes, along with their English teachers, enjoyed the sunny weather and chocolate crepes and pancakes in our annual crepe breakfast feast.Thanks to all the moms and dads for sending such yummy crepes and pancakes.WE ENJOYED IT!GELENEKSEL KREP GÜNÜOkulumuz 5. sınıf öğrencileri, İngilizce öğretmenleri ile birlikte geleneksel krep gününde buluşarak okulumuz bahçesinde güneşli havanın ve çikolatalı kreplerin tadını çıkardılar.Bu lezzetli krepler için tüm anne ve babalara teşekkür ederiz.",
    "gallery": [
      "/files/images/l2132017104922377.jpg",
      "/files/images/l2132017105022175.jpg",
      "/files/images/l2132017105022971.jpg",
      "/files/images/l2132017105122924.jpg",
      "/files/images/l2132017105222658.jpg",
      "/files/images/l2132017105322456.jpg",
      "/files/images/l2132017105422221.jpg"
    ],
    "video": ""
  },
  {
    "id": "grade-5-spelling-bee",
    "title": "GRADE 5 SPELLING BEE",
    "image": "/files/images/l2132017103120689.jpg",
    "description": "GRADE 5 SPELLING BEEOrtaokul beşinci sınıf öğrencileri arasında düzenlenen \"Spelling Bee\" adlı heceleme yarışmasında birbirlerine karşı yarıştı. Çekişmeli geçen mücadele sonucu dereceye giren öğrenciler sinema bileti ödülünü kazandılar.We spent an exciting afternoon watching our grade five students compete in our annual SPELLING BEE.   Round by round the group of over 20 competitors shrank until we had our three finalists.  With the grade four classes watching we were able to announce this year's three  SPELLING BEE champions.This year's SPELLING BEE hourors went to EFE AHMETLER, DAMLA YELİZ BAKIR and KIVANÇ GÜVEN.The winners of the 2016-2017 Grade 5 Spelling Bee spelling competition were presented with certificates and a ticket each to see Moana in the movie theater.Congratulations to all the contestants and best wishes for next time!",
    "gallery": [
      "/files/images/l2132017103120689.jpg",
      "/files/images/l2132017103120861.jpg",
      "/files/images/l21320171032202.jpg",
      "/files/images/l2132017103220174.jpg"
    ],
    "video": ""
  },
  {
    "id": "2016-macmillan-readers-shakespeare-competition-results",
    "title": "2016 MACMILLAN READERS SHAKESPEARE COMPETITION RESULTS",
    "image": "/files/images/l2132017102918411.jpg",
    "description": "2016 MACMILLAN READERS SHAKESPEARE COMPETITION RESULTS2016 MACMILLAN READERS SHAKESPEARE COMPETITION RESULTSA handful of students throughout our school produced written and illustrated entries to be entered in the 2016 MACMILLAN READERS SHAKESPEARE COMPETITION,  an international competition comemorating the 400thanniversary of William Shakespeare's death.Out of over 600 entries the story written by our grade 7 student, MAYA ASENA KARAKAYA, was awarded top prize in its category.We are proud of all the entrants for their hard work and truly remarkable efforts.MACMILLIAN READERS SHAKESPEARE YARIŞMASIWilliam Shakespeare'in 400. ölüm yıldönümü anma etkinliklerinden olan Uluslararası 2016 MACMILLIAN READERS SHAKESPEARE yarışmasına öğrencilerimiz de katılmıştır. Yarışmaya katılan 600 kişiden 7. sınıf öğrencimiz Maya Asena Karakaya yazdığı hikaye ile bu kategoride birincilik elde etmiştir. Yarışmaya katılan tüm öğrencilerimizi bu değerli çalışmaları için tebrik ediyoruz.",
    "gallery": [
      "/files/images/l2132017102918411.jpg",
      "/files/images/l2132017102918550.jpg"
    ],
    "video": ""
  },
  {
    "id": "kasim-ayi-ikinci-haftasi-dis-sagligi-sunumu-",
    "title": "Kasım ayı ikinci haftası diş sağlığı sunumu ",
    "image": "/files/images/l10320171264823.jpg",
    "description": "Kasım ayı ikinci haftası diş sağlığı sunumu5.,6.ve 7.  sınıf öğrencilerimize Diş Hekmi Salim Bayram “Dişlerimiz ve diş sağlığı “ konulu sunumunu gerçekleştirmiştir.",
    "gallery": [
      "/files/images/l10320171264823.jpg",
      "/files/images/l103201712268245.jpg",
      "/files/images/l103201712268339.jpg"
    ],
    "video": ""
  },
  {
    "id": "29-cumhuriyet--bayrami-kapsaminda-siniflar-arasi-basketbol-turnuvalarinin-duzenlenmesi",
    "title": "29 Cumhuriyet  Bayramı kapsamında sınıflar arası basketbol turnuvalarının düzenlenmesi",
    "image": "/files/images/l1032017111648289.jpg",
    "description": "29 Cumhuriyet  Bayramı kapsamında sınıflar arası basketbol turnuvalarının düzenlenmesi29 Cumhuriyet  Bayramı kapsamında sınıflar arası basketbol turnuvalarının düzenlenmesi",
    "gallery": [
      "/files/images/l1032017111648289.jpg",
      "/files/images/l1032017111648540.jpg",
      "/files/images/l1032017111648774.jpg",
      "/files/images/l1032017111648979.jpg"
    ],
    "video": ""
  },
  {
    "id": "tubitak-bilim-senligine-gezisi",
    "title": "Tubitak bilim şenliğine gezisi",
    "image": "/files/images/l1032017114942929.jpg",
    "description": "Tubitak bilim şenliğine gezisiMersin’de düzenlenmiş olan bilim şenliğine okulumuzdan 5-6-7.  Sınıflar katılmuş olup TUBİTAK  tarafından seçilmiş olan projeler ilgiyle incelenmiştir.",
    "gallery": [
      "/files/images/l1032017114942929.jpg",
      "/files/images/l1032017115042101.jpg",
      "/files/images/l1032017115042289.jpg"
    ],
    "video": ""
  },
  {
    "id": "trt-cukurova-radyosuna--iletisimin-onemi-ile-ilgili-gezi-yapildi",
    "title": "Trt çukurova radyosuna  iletişimin önemi ile ilgili gezi yapıldı",
    "image": "/files/images/l1032017113339929.jpg",
    "description": "Trt çukurova radyosuna  iletişimin önemi ile ilgili gezi yapıldıTrt Çukurova Radyosuna yaptığımız ziyaret ile trt prodüktörü Lütfü KILINÇTAN  iletişim  ve iletişimin  önemi konusunda bilgi alındı. Canlı yayın stüdyosunda izlenimlerde bulundu.",
    "gallery": [
      "/files/images/l1032017113339929.jpg",
      "/files/images/l103201711343938.jpg",
      "/files/images/l1032017113439179.jpg",
      "/files/images/l1032017113439304.jpg"
    ],
    "video": ""
  },
  {
    "id": "12-ekim-zicev-e-destek",
    "title": "12 Ekim Ziçev e destek",
    "image": "/files/images/l103201711134772.jpg",
    "description": "12 Ekim Ziçev e destek12 Ekim 2016 tarihine yapılan  ZİÇEV  “Engelleri Sanatla Aşıyoruz Projesi kapsamında resim sergisine gidilerek  Dawn Sendromlu çocuklarımıza destek verdik.",
    "gallery": [
      "/files/images/l103201711134772.jpg",
      "/files/images/l103201711134944.jpg",
      "/files/images/l103201711234116.jpg"
    ],
    "video": ""
  },
  {
    "id": "ortaokul-8-sinif-ogrencimiz-deniz-kenan-ek-in-naturmort-karakalem-sergisini-actik",
    "title": "Ortaokul 8. Sınıf öğrencimiz Deniz Kenan Ek'in natürmort karakalem sergisini açtık.",
    "image": "/files/images/l832017215441485.jpg",
    "description": "Ortaokul 8. Sınıf öğrencimiz Deniz Kenan Ek'in natürmort karakalem sergisini açtık.Ortaokul 8. Sınıf öğrencimiz Deniz Kenan Ek'in natürmort karakalem sergisini açtık. Öğrencimizi tebrik ediyor, başarılarının devamını diliyoruz.",
    "gallery": [
      "/files/images/l832017215441485.jpg",
      "/files/images/l832017215441704.jpg",
      "/files/images/l832017215441938.jpg",
      "/files/images/l832017215541141.jpg",
      "/files/images/l832017215541313.jpg",
      "/files/images/l832017215541532.jpg",
      "/files/images/l832017215541719.jpg",
      "/files/images/l832017215541938.jpg",
      "/files/images/l83201721564194.jpg",
      "/files/images/l832017215641251.jpg",
      "/files/images/l832017215641391.jpg",
      "/files/images/l832017215641594.jpg",
      "/files/images/l832017215641735.jpg",
      "/files/images/l832017215641876.jpg",
      "/files/images/l83201721574116.jpg",
      "/files/images/l832017215741188.jpg",
      "/files/images/l832017215741329.jpg"
    ],
    "video": "https://www.youtube.com/embed/f3MHUjJnGYc?ecver=1"
  },
  {
    "id": "karakalem-naturmort-sergisi",
    "title": "Karakalem natürmort sergisi",
    "image": "/files/images/l53201723443516.jpg",
    "description": "Karakalem natürmort sergisiOrtaokul 8. sınıf öğrencimiz Deniz Kenan Ek 'in hazırlamış olduğu karakalem natürmort sergisine 8 Mart Çarşamba Günü  tüm okulumuz davetlidir.",
    "gallery": [
      "http://www.guneygelisim.k12.tr/files/images/c53201723482375.jpg.jpg",
      "/files/images/l53201723443516.jpg"
    ],
    "video": ""
  },
  {
    "id": "sanatla-zamanda-sonsuz--yolculuk--konulu-resim-sergisi",
    "title": "Sanatla Zamanda Sonsuz  Yolculuk  konulu resim sergisi",
    "image": "/files/images/l53201722111805.jpg",
    "description": "Sanatla Zamanda Sonsuz  Yolculuk  konulu resim sergisiOrtaokul öğrencilerimiz 3 Nisan Pazartesi günü Mersin Forum AVM' de açılacak olan 'Sanatla Zamanda Sonsuz  Yolculuk' konulu resim sergisine hızla hazırlanmaya devam ediyor...",
    "gallery": [
      "/files/images/l53201722111805.jpg",
      "/files/images/l53201722111945.jpg",
      "/files/images/l53201722121101.jpg",
      "/files/images/l53201722121242.jpg",
      "/files/images/l53201722121398.jpg",
      "/files/images/l53201722121539.jpg",
      "/files/images/l53201722121680.jpg",
      "/files/images/l53201722121789.jpg",
      "/files/images/l53201722121914.jpg",
      "/files/images/l5320172213123.jpg",
      "/files/images/l53201722131117.jpg"
    ],
    "video": ""
  },
  {
    "id": "kucuk-kiz-takimimiz-ceyrek-finalde",
    "title": "KÜÇÜK KIZ TAKIMİMİZ ÇEYREK FİNALDE",
    "image": "/files/images/l102201703559164.jpg",
    "description": "KÜÇÜK KIZ TAKIMİMİZ ÇEYREK FİNALDEKÜÇÜK KIZ TAKIMIMIZ ÇEYREK FİNALDE...",
    "gallery": [
      "/files/images/l102201703559164.jpg"
    ],
    "video": ""
  },
  {
    "id": "yildiz-kiz-voleybol-takimimiz-mersin-ucuncusu-olarak-maclarini-tamamladilar",
    "title": "YILDIZ KIZ VOLEYBOL TAKIMIMIZ MERSİN ÜÇÜNCÜSÜ OLARAK MAÇLARINI TAMAMLADILAR",
    "image": "/files/images/l1512017222949928.jpg",
    "description": "YILDIZ KIZ VOLEYBOL TAKIMIMIZ MERSİN ÜÇÜNCÜSÜ OLARAK MAÇLARINI TAMAMLADILARYILDIZ KIZ VOLEYBOL TAKIMIMIZ MERSİN ÜÇÜNCÜSÜ OLARAK MAÇLARINI TAMAMLADILAR. HEPSİNİ TEK TEK TEBRİK EDİYORUZ.",
    "gallery": [
      "/files/images/l1512017222949928.jpg",
      "/files/images/l2312017234514235.jpg",
      "/files/images/l231201723101516.jpg"
    ],
    "video": ""
  },
  {
    "id": "voleybol-kucuk-kiz-takimimiz-grup-birincisi-olarak-2tura-yukseldi",
    "title": "VOLEYBOL KÜÇÜK KIZ TAKIMIMIZ GRUP BİRİNCİSİ OLARAK 2.TURA YÜKSELDİ.",
    "image": "/files/images/l131201792510278.jpg",
    "description": "VOLEYBOL KÜÇÜK KIZ TAKIMIMIZ GRUP BİRİNCİSİ OLARAK 2.TURA YÜKSELDİ.VOLEYBOL KÜÇÜK KIZ TAKIMIMIZ GRUP BİRİNCİSİ OLARAK 2.TURA YÜKSELDİ.",
    "gallery": [
      "/files/images/l131201792510278.jpg"
    ],
    "video": ""
  },
  {
    "id": "yari-final-maclarinda-basarilar-dileriz",
    "title": "Yarı final maçlarında başarılar dileriz",
    "image": "/files/images/l41201714155833.jpg",
    "description": "Yarı final maçlarında başarılar dilerizGüney Gelişim Koleji Küçük ve yıldız basketbol takımı Mersin yarı finaline kalmıştır.  Yarı final maçlarında başarılar dileriz",
    "gallery": [
      "/files/images/l41201714155833.jpg",
      "/files/images/l41201714155989.jpg",
      "/files/images/l41201714255177.jpg"
    ],
    "video": ""
  },
  {
    "id": "losev-yararina-garaj-satisi",
    "title": "Lösev yararına garaj satışı",
    "image": "/files/images/l2812201620378212.jpg",
    "description": "Lösev yararına garaj satışı9 Aralık Cuma günü 2. El eşyaların satışının gerçekleştiği garaj satışlarından elde edilen gelir ile Mersin Üniversitesi hematolojionkoloji bölümüne bağışımızı gerçekleştirdik.  Bağış yapan 14 öğrencilerimizle birlikte  hastaneye düzenlediğimiz gezide bizimleilgilenen bölüm başkanı  Prof.dr. Eyüp Naci Tiftik ve tüm uzmanlara teşekkür ederiz.",
    "gallery": [
      "/files/images/l2812201620378212.jpg",
      "/files/images/l2812201620378290.jpg",
      "/files/images/l2812201620378400.jpg",
      "/files/images/l2812201620378478.jpg"
    ],
    "video": ""
  },
  {
    "id": "8-siniflarimiz-kapadokya-gezisinen-kareler-",
    "title": "8. SINIFLARIMIZ KAPADOKYA GEZİSİNEN KARELER... ",
    "image": "/files/images/l312201619473353.jpg",
    "description": "8. SINIFLARIMIZ KAPADOKYA GEZİSİNEN KARELER...8. SINIFLARIMIZ KAPADOKYA GEZİSİNEN KARELER...",
    "gallery": [
      "/files/images/l312201619473353.jpg",
      "/files/images/l3122016194733162.jpg",
      "/files/images/l3122016194733288.jpg",
      "/files/images/l3122016194733428.jpg",
      "/files/images/l3122016194733584.jpg",
      "/files/images/l3122016194234444.jpg"
    ],
    "video": "https://www.youtube.com/embed/d_juBaPbU4k"
  },
  {
    "id": "8-siniflarimiz-kapadokya-gezisine-hazirlaniyor",
    "title": "8. SINIFLARIMIZ KAPADOKYA GEZİSİNE HAZIRLANIYOR...",
    "image": "/files/images/l3011201683259483.jpg",
    "description": "8. SINIFLARIMIZ KAPADOKYA GEZİSİNE HAZIRLANIYOR...",
    "gallery": [
      "/files/images/l3011201683259483.jpg"
    ],
    "video": ""
  },
  {
    "id": "diyabet-ile-ilgili-bilgilendirme-sunumu",
    "title": "Diyabet ile ilgili bilgilendirme sunumu",
    "image": "/files/images/l22112016132831218.jpg",
    "description": "Diyabet ile ilgili bilgilendirme sunumu17 Kasım Perşembe günü diyabet ile ilgili bilgilendirme yapmak ve obeziteyle savaş konularını anlatmak üzere Uzman Çocuk DoktoruNalan Deniz okulumuzda sunum yapmıştır. Ayrıca lösemili çocuklara yardım yapmak amacıyla lösev ile ilgili bilgilendirme yapılmıştır.Nalan Deniz'e yaptığı sunum için teşekkür ediyoruz.",
    "gallery": [
      "/files/images/l22112016132831218.jpg",
      "/files/images/l22112016132831359.jpg",
      "/files/images/l22112016132831515.jpg",
      "/files/images/l22112016132831640.jpg",
      "/files/images/l22112016132736922.jpg"
    ],
    "video": ""
  },
  {
    "id": "teogda-basarilar-dileriz",
    "title": "TEOGDA BAŞARILAR DİLERİZ.",
    "image": "/images2/img2_files/logo.jpg",
    "description": "TEOGDA BAŞARILAR DİLERİZ.Tüm 8. Sınıf öğrencilerimize başarılar dileriz.",
    "gallery": [
      "http://www.guneygelisim.k12.tr/files/images/c2211201691049408.jpg.jpg"
    ],
    "video": ""
  },
  {
    "id": "5--sinif-antalya-kampindan-kareler",
    "title": "5 . Sınıf Antalya Kampından kareler...",
    "image": "/images2/img2_files/logo.jpg",
    "description": "5 . Sınıf Antalya Kampından kareler...5 . Sınıf Antalya Kampından kareler...",
    "gallery": [],
    "video": "//www.dailymotion.com/embed/video/k2PpTj68HnRHv4kB0tl"
  },
  {
    "id": "6sinif-kahvalti-etkinligimiz",
    "title": "6.SINIF KAHVALTI ETKİNLİĞİMİZ",
    "image": "/files/images/t_DSC_5531732440.JPG",
    "description": "6.SINIF KAHVALTI ETKİNLİĞİMİZ6.sınıf öğrencilerimizle eğitim - öğretim yılı yorgunluğunu, kahvaltı etkinliği ve spor faaliyetleriyle üzerimizden attık.",
    "gallery": [
      "/files/images/t_DSC_5531732440.JPG",
      "/files/images/t_DSC_3187524677.JPG",
      "/files/images/t_DSC_8344995379.JPG",
      "/files/images/t_DSC_2568323016.JPG"
    ],
    "video": ""
  },
  {
    "id": "cevre-sorunlari-ve-nukleer-enerji-konulu-seminer",
    "title": "ÇEVRE SORUNLARI ve NÜKLEER ENERJİ KONULU SEMİNER",
    "image": "/files/images/t_IMG_9296991229.jpg",
    "description": "ÇEVRE SORUNLARI ve NÜKLEER ENERJİ KONULU SEMİNEREco okul projesi çerçevesinde ÇYDD derneğinden Gülümser Okyay \"Çevre sorunları ve nükleer enerji  konusunda \" öğrencilerimize bilgilendirmede bulundu. Verdiği değerli bilgiler için kendisine teşekkür ediyoruz.",
    "gallery": [
      "/files/images/t_IMG_9296991229.jpg"
    ],
    "video": ""
  },
  {
    "id": "komsu-koyun-delisi",
    "title": "KOMŞU KÖYÜN DELİSİ",
    "image": "/files/images/t_DSC_5418512225.jpg",
    "description": "KOMŞU KÖYÜN DELİSİÖğrencilerimiz, büyük bir emek ve istekle hazırladıkları “Bizim Köyün Delisi” isimli Tiyatro oyununu,  yeni binamızın görkemli salonunda sundular.Önce İlkokul, daha sonra da ortaokul öğrenci ve velilerimizin izlediği, büyük beğeni kazanan oyunun usta sanatçıları olan öğrencilerimizi kutluyoruz.Emeği geçen tüm öğretmenlerimize de teşekkürler….",
    "gallery": [
      "/files/images/t_DSC_5418512225.jpg",
      "/files/images/t_DSC_2799646259.jpg",
      "/files/images/t_DSC_3742792010.jpg",
      "/files/images/t_DSC_4637262225.jpg",
      "/files/images/t_DSC_9073144793.jpg",
      "/files/images/t_DSC_5241205096.jpg",
      "/files/images/t_DSC_9589197039.jpg",
      "/files/images/t_DSC_6078302264.jpg",
      "/files/images/t_DSC_636560321.jpg",
      "/files/images/t_DSC_476343036.jpg",
      "/files/images/t_DSC_534479022.jpg",
      "/files/images/t_DSC_4894830585.jpg",
      "/files/images/t_DSC_6275903582.jpg",
      "/files/images/t_DSC_2812921405.jpg",
      "/files/images/t_DSC_2748529315.jpg",
      "/files/images/t_DSC_1026422382.jpg"
    ],
    "video": ""
  },
  {
    "id": "and-now-we-are-in-finland",
    "title": "AND NOW WE ARE IN FİNLAND",
    "image": "/files/images/t_1.j_8854638934.jpg",
    "description": "AND NOW WE ARE IN FİNLANDOur English department head Filiz Yakupoğlu, our english teachers Julia Karakaya and Ergün Eren & our science teacher  Yusuf Uğur  have taken  15 students of our  7th graders to Kotimaki  School in Turku, Finland to participate in the first of two international  visits for our shared Erasmus Project title “our visiting birds friends.”And Finnish press wrote something  about our project.",
    "gallery": [
      "/files/images/t_1.j_8854638934.jpg",
      "/files/images/t_2.j_2564813495.jpg",
      "/files/images/t_3.j_8121148944.jpg",
      "/files/images/t_4.j_5015680194.jpg",
      "/files/images/t_5.j_2407037616.jpg",
      "/files/images/t_6.j_8013269305.jpg",
      "/files/images/t_7.j_8819391131.jpg",
      "/files/images/t_8.j_9007532000.jpg",
      "/files/images/t_9.j_3848077655.jpg",
      "/files/images/t_10._3160058856.jpg",
      "/files/images/t_11._8769800067.jpg",
      "/files/images/t_12._2180292011.jpg",
      "/files/images/t_13._7636834979.jpg",
      "/files/images/t_14._5289575458.jpg",
      "/files/images/t_15._708886981.jpg",
      "/files/images/t_16._3839532733.jpg",
      "/files/images/t_18._6665613055.jpg",
      "/files/images/t_19._6287958026.jpg",
      "/files/images/t_20._3920862079.jpg",
      "/files/images/t_17._6025659442.jpg"
    ],
    "video": ""
  },
  {
    "id": "5-siniflar-kermesi",
    "title": "5. SINIFLAR KERMESİ",
    "image": "/files/images/t_IMG_279046894.jpg",
    "description": "5. SINIFLAR KERMESİÖğrenci meclisinin aldığı kararla 5. sınıflarımız \"Mersin Üniversitesi hayvan barınağına destek vermek için kermes düzenlediler. Öğrencilerimize ve velilerimize gösterdikleri ilgiden dolayı teşekkür ederiz",
    "gallery": [
      "/files/images/t_IMG_279046894.jpg",
      "/files/images/t_IMG_4784662128.jpg",
      "/files/images/t_IMG_3199121356.jpg",
      "/files/images/t_IMG_8441583514.jpg"
    ],
    "video": ""
  },
  {
    "id": "mersin-universitesi-hayvan-barinagi-ziyareti",
    "title": "MERSİN ÜNİVERSİTESİ HAYVAN BARINAĞI ZİYARETİ",
    "image": "/files/images/t_IMG_4644739032.jpg",
    "description": "MERSİN ÜNİVERSİTESİ HAYVAN BARINAĞI ZİYARETİ5A ve 5B sınıflarımız kermeste elde ettiği gelirle aldıkları mamaları Mersin Üniversitesi hayvan barınağı görevlilerine teslim ettiler. Barınakta yaşayan kedi ve köpekler hakkında bilgi aldılar. Hayvan dostlarımıza nasıl davranmamız ve nasıl bakmamız gerektiği hakkında bilgi veren görevlilere teşekkür ediyoruz.",
    "gallery": [
      "/files/images/t_IMG_4644739032.jpg",
      "/files/images/t_IMG_7196924090.jpg",
      "/files/images/t_IMG_9438287615.jpg"
    ],
    "video": ""
  },
  {
    "id": "tubitak-fuari-gezisi",
    "title": "TÜBİTAK FUARI GEZİSİ",
    "image": "/files/images/t_IMG_9962121844.jpg",
    "description": "TÜBİTAK FUARI GEZİSİ5. ve 7. sınıflarımız  TÜBİTAK'ın düzenlediği 46. Orta Öğretim Öğrencilerinin sergilendiği  araştırma projelerinin sergilendiği bilim fuarını ziyaret edip projeye katılan öğrencilerden Fen ve Sosyal Bilim projeleri hakkında bilgi aldılar. Bilimsel projelerin nasıl hazırlanıp sunulduğunu izledikleri örneklerle öğrendiler.",
    "gallery": [
      "/files/images/t_IMG_9962121844.jpg",
      "/files/images/t_IMG_9983636736.jpg",
      "/files/images/t_IMG_3137170673.jpg",
      "/files/images/t_IMG_6904718280.jpg",
      "/files/images/t_IMG_9835016131.jpg",
      "/files/images/t_IMG_8800165057.jpg",
      "/files/images/t_IMG_4596063495.jpg"
    ],
    "video": ""
  },
  {
    "id": "kutuphaneler-haftasi",
    "title": "KÜTÜPHANELER HAFTASI",
    "image": "/files/images/t_IMG_5456811786.jpg",
    "description": "KÜTÜPHANELER HAFTASI51. Kütüphaneler haftasında 5.sınıflarımızla \" İl Halk Kütüphanesini\" ziyaret ettik. Öğrencilerimiz araştırma yaparken kütüphaneden nasıl yararlanacağını öğrendiler ve dünya  kütüphaneleri hakkında bilgi aldılar.",
    "gallery": [
      "/files/images/t_IMG_5456811786.jpg",
      "/files/images/t_IMG_5480157733.jpg",
      "/files/images/t_IMG_1453515888.jpg",
      "/files/images/t_IMG_9921838641.jpg"
    ],
    "video": ""
  },
  {
    "id": "dis-sagligi-sunumu",
    "title": "DİŞ SAĞLIĞI SUNUMU",
    "image": "/files/images/t_IMG_7824212908.jpg",
    "description": "DİŞ SAĞLIĞI SUNUMUDiş hekimi Nilüfer Karaselçuk 5. sınıf öğrencilerimize diş sağlığı ve dişlerimizin temizliği ile ilgili sunum yaptı.",
    "gallery": [
      "/files/images/t_IMG_7824212908.jpg",
      "/files/images/t_IMG_6635400653.jpg",
      "/files/images/t_IMG_9133417010.jpg",
      "/files/images/t_IMG_5579797625.jpg",
      "/files/images/t_IMG_5494043231.jpg",
      "/files/images/t_IMG_2973749042.jpg",
      "/files/images/t_IMG_1559259296.jpg"
    ],
    "video": ""
  },
  {
    "id": "resim-yarismasinda-derece",
    "title": "RESİM YARIŞMASINDA DERECE",
    "image": "/files/images/t_DSC_9379541277.jpg",
    "description": "RESİM YARIŞMASINDA DERECEUluslararası Sanat Kolonisi ve Doğa Park işbirliği ile düzenlenen resim yarışmasında dereceye girerek, Akdeniz bölge birincisi ve üçüncüsü olan öğrencilerimiz Zeynep Duru Aydın, Lavin Demirhan ve Ravel Deniz Saygı'yı kutluyor, başarılarının devamını diliyoruz.",
    "gallery": [
      "/files/images/t_DSC_9379541277.jpg"
    ],
    "video": ""
  },
  {
    "id": "today-a-reader-tomorrow-a-leader",
    "title": "TODAY a READER TOMORROW a LEADER",
    "image": "/files/images/t_1.j_883142353.jpg",
    "description": "TODAY a READER TOMORROW a LEADERWe congratulate all of our top Grade 3 readers for reporting on books from the English library throughtout the school yearThe English DepartmentYıl boyunca İngilizce kütüphanemizden en çok kitap okuyan 3. sınıf öğrencile-rimizi tebrik ediyoruz.İngilizce Bölümü",
    "gallery": [
      "/files/images/t_1.j_883142353.jpg",
      "/files/images/t_2.j_7706567645.jpg",
      "/files/images/t_3.j_2367669940.jpg",
      "/files/images/t_8.j_1040765644.jpg",
      "/files/images/t_9.j_4475519061.jpg",
      "/files/images/t_11._9415094256.jpg"
    ],
    "video": ""
  },
  {
    "id": "resim-sergimiz",
    "title": "RESİM SERGİMİZ",
    "image": "/images2/img2_files/logo.jpg",
    "description": "RESİM SERGİMİZsergimpaylaşan:dm_51f91a1f906b4",
    "gallery": [],
    "video": "http://www.dailymotion.com/embed/video/x1txku7"
  },
  {
    "id": "ingilizce-tiyatro",
    "title": "İNGİLİZCE TİYATRO",
    "image": "/files/images/t_I2._5311242938.jpg",
    "description": "İNGİLİZCE TİYATRO27 Mart Dünya Tiyatrolar Gününde “Peter  Pan “  adlı İngilizce oyunumuz  5. Sınıf öğrencilerimiz tarafından  sahnelenmiştir. Katılan öğrencilerimize teşekkür ederiz.",
    "gallery": [
      "/files/images/t_I2._5311242938.jpg",
      "/files/images/t_I3._740472675.jpg",
      "/files/images/t_I4._8702356219.jpg",
      "/files/images/t_111_2978326678.jpg"
    ],
    "video": ""
  },
  {
    "id": "mersin-deniz-muzesi",
    "title": "MERSİN DENİZ MÜZESİ",
    "image": "/files/images/t_1.j_3832055926.jpg",
    "description": "MERSİN DENİZ MÜZESİ7A ve 7B sınıfı öğrencileri Sosyal Bilgiler dersinde öğrendikleri \"Osmanlıda Denizcilik ve Deniz Savaşları\" konusunu Denizcilik  Müzesini ziyaret ederek izledikleri görsellerle pekiştirdiler.",
    "gallery": [
      "/files/images/t_1.j_3832055926.jpg",
      "/files/images/t_2.j_7302362323.jpg",
      "/files/images/t_3.j_8127405047.jpg",
      "/files/images/t_4.j_4410516620.jpg",
      "/files/images/t_5.j_9715997576.jpg",
      "/files/images/t_6.j_9782983660.jpg",
      "/files/images/t_7.j_244714618.jpg",
      "/files/images/t_8.j_2892267108.jpg",
      "/files/images/t_9.j_2235071063.jpg"
    ],
    "video": ""
  },
  {
    "id": "yeniyil",
    "title": "YENİYIL",
    "image": "/files/images/t_1.j_6586877704.jpg",
    "description": "YENİYIL5,6,7,8. Sınıflarımız, öğrenci meclisinin hazırladığı çayda; I.Dönemin yorgunluğunu atıp , yeni yıla merhaba dediler.Bütün arkadaşlarımıza mutlu,sağlıklı ve başarılı bir yıl diliyoruz.Öğrenci meclisi adına Meclis BaşkanıKerem TARCAN",
    "gallery": [
      "/files/images/t_1.j_6586877704.jpg",
      "/files/images/t_2.j_3658410907.jpg",
      "/files/images/t_3.j_4180261493.jpg",
      "/files/images/t_4.j_4229852557.jpg",
      "/files/images/t_6.j_5995447040.jpg",
      "/files/images/t_7.j_1204950214.jpg"
    ],
    "video": ""
  },
  {
    "id": "kulturlerimizi-taniyalim",
    "title": "KÜLTÜRLERİMİZİ TANIYALIM..",
    "image": "/files/images/t_1.j_8346521258.jpg",
    "description": "KÜLTÜRLERİMİZİ TANIYALIM..5. Sınıfların \"Kültürlerimizi Tanıyalım\" etkinliği5. sınıf öğrencilerimiz Sosyal Bilgiler dersinin “kültür\" konulu etkinliğinde, yemek kültürümüzü anlatırken getirdikleri yöresel yiyeceklerimizi birbirlerine ikram ederek tanıttılar.",
    "gallery": [
      "/files/images/t_1.j_8346521258.jpg",
      "/files/images/t_2.j_9216424822.jpg",
      "/files/images/t_3.j_6951867938.jpg",
      "/files/images/t_4.j_2359735370.jpg",
      "/files/images/t_5.j_522729755.jpg",
      "/files/images/t_6.j_1271936298.jpg"
    ],
    "video": ""
  },
  {
    "id": "karagoz-ve-hacivat",
    "title": "KARAGÖZ ve HACİVAT",
    "image": "/files/images/t_1.j_7832605242.jpg",
    "description": "KARAGÖZ ve HACİVAT5. Sınıflarımız  ”Karagöz ve Hacivat “ etkinliğini gerçekleştirdi.5. Sınıf öğrencilerimiz sosyal bilgiler dersinde hazırlayıp sundukları  “Karagöz ve Hacivat” etkinliği ile kültürel değerlerimize sahip çıkıp, bu değerlerimizi birbirlerine tanıttılar.",
    "gallery": [
      "/files/images/t_1.j_7832605242.jpg",
      "/files/images/t_2.j_9070703387.jpg",
      "/files/images/t_3.j_8278161883.jpg",
      "/files/images/t_4.j_6913873553.jpg",
      "/files/images/t_5.j_1953546405.jpg",
      "/files/images/t_6.j_8472711444.jpg"
    ],
    "video": ""
  },
  {
    "id": "5siniflara-tesekkur-mesaji-",
    "title": "5.SINIFLARA TEŞEKKÜR MESAJI ",
    "image": "/files/images/t_alt_6437188983.jpg",
    "description": "5.SINIFLARA TEŞEKKÜR MESAJIKamp sonrası yorgunluğumuza rağmenATAMIZIanma törenine katılmak için okulumuzda toplandık.Teşekkürler...Kaan Efe,Elif Ece,Şinda, Barış, Azra, Hakan, Onur, Ekin, Yusuf Efe, Ruken, Kayra, Özcan, Tara, Aslı, Umut Doğan, Elif, İdil, Ali Efe ve Çağla Su.",
    "gallery": [
      "/files/images/t_alt_6437188983.jpg"
    ],
    "video": ""
  },
  {
    "id": "10-kasim-video",
    "title": "10 KASIM VİDEO",
    "image": "/images2/img2_files/logo.jpg",
    "description": "10 KASIM VİDEO",
    "gallery": [],
    "video": "http://www.dailymotion.com/embed/video/x171wwn"
  },
  {
    "id": "10-kasim-ataturk-u-anma-gunu",
    "title": "10 Kasım Atatürk`ü Anma Günü",
    "image": "/files/images/t_Ima_3154718280.jpg",
    "description": "10 Kasım Atatürk`ü Anma Günü10 Kasım sadece Atatürk'ü anmak değil onun mücadele azmini, bizlere yüklediği sorumlulukları ve gösterdiği hedefleri hatırlamak , bunları uygulamaktır.Mustafa Kemal bağımsızlık demektir, Mustafa Kemal vatan demektir, Mustafa Kemal onurlu bir yaşam demektir. Onu unutmamalı ve unutturmamalıyız.Bu düşünceler ışığında ülkemizin değil aynı zamanda dünyanın da en önemli liderlerinden olan Mustafa Kemal Atatürk'ü sevgiyle anıyor, onun eşsiz hatırası önünde saygıyla eğiliyoruz.",
    "gallery": [
      "/files/images/t_Ima_3154718280.jpg",
      "/files/images/t_Ima_8820917010.jpg",
      "/files/images/t_Ima_4097253680.jpg",
      "/files/images/t_Ima_5488550067.jpg",
      "/files/images/t_Ima_125543476.jpg",
      "/files/images/t_Ima_3290979266.jpg",
      "/files/images/t_Ima_1633722186.jpg",
      "/files/images/t_Ima_3732110858.jpg",
      "/files/images/t_Ima_4547387958.jpg",
      "/files/images/t_Ima_7754327655.jpg",
      "/files/images/t_Ima_1951104999.jpg",
      "/files/images/t_Ima_7396966815.jpg"
    ],
    "video": ""
  },
  {
    "id": "cumhuriyet-ve-ataturk",
    "title": "CUMHURİYET ve ATATÜRK",
    "image": "/files/images/t_1.j_4720575213.jpg",
    "description": "CUMHURİYET ve ATATÜRK8.sınıf öğrencilerimizden Yasemin Karamaya ve Kerem Tarcan\"Cumhuriyet ve Atatürk\"adlı sunumu yapıp; Cumhuriyetimizi neden korumamız gerektiğini ve önemini anlattılar.Atatürkçü Düşünce Derneğin'den gelen konuklarımız ise\"Atatürk'ü ve bize kazandırdığı devrimlerin önemini\"anlatıp kavrattılar.Konuklarımıza ve Öğrencilerimize bize verdikleri değerli bilgiler ve kazanımlar için teşekkür ederiz.",
    "gallery": [
      "/files/images/t_1.j_4720575213.jpg",
      "/files/images/t_2.j_5422937274.jpg",
      "/files/images/t_3.j_4011957049.jpg",
      "/files/images/t_4.j_9100305438.jpg"
    ],
    "video": ""
  },
  {
    "id": "10-kasim-ataturk-u-anma-gunu",
    "title": "10 Kasım Atatürk`ü Anma Günü",
    "image": "/images2/img2_files/logo.jpg",
    "description": "10 Kasım Atatürk`ü Anma Günü10 Kasım sadece Atatürk'ü anmak değil onun mücadele azmini, bizlere yüklediği sorumlulukları ve gösterdiği hedefleri hatırlamak , bunları uygulamaktır.Mustafa Kemal bağımsızlık demektir, Mustafa Kemal vatan demektir, Mustafa Kemal onurlu bir yaşam demektir. Onu unutmamalı ve unutturmamalıyız.Bu düşünceler ışığında ülkemizin değil aynı zamanda dünyanın da en önemli liderlerinden olan Mustafa Kemal Atatürk'ü sevgiyle anıyor, onun eşsiz hatırası önünde saygıyla eğiliyoruz.",
    "gallery": [
      "/files/images/t_Ima_3154718280.jpg",
      "/files/images/t_Ima_8820917010.jpg",
      "/files/images/t_Ima_4097253680.jpg",
      "/files/images/t_Ima_5488550067.jpg",
      "/files/images/t_Ima_125543476.jpg",
      "/files/images/t_Ima_3290979266.jpg",
      "/files/images/t_Ima_1633722186.jpg",
      "/files/images/t_Ima_3732110858.jpg",
      "/files/images/t_Ima_4547387958.jpg",
      "/files/images/t_Ima_7754327655.jpg",
      "/files/images/t_Ima_1951104999.jpg",
      "/files/images/t_Ima_7396966815.jpg"
    ],
    "video": ""
  },
  {
    "id": "saglikli-beslenme",
    "title": "SAĞLIKLI BESLENME",
    "image": "/files/images/t_1.j_9672052264.jpg",
    "description": "SAĞLIKLI BESLENMEDiyetisyenSimay Altuneşliğinde 5. Sınıf öğrencilerimize dengeli beslenmenin önemi konusunda sunum yapıldı.",
    "gallery": [
      "/files/images/t_1.j_9672052264.jpg",
      "/files/images/t_2.j_2136651874.jpg",
      "/files/images/t_3.j_5174219012.jpg",
      "/files/images/t_4.j_180627704.jpg",
      "/files/images/t_5.j_3332177997.jpg",
      "/files/images/t_6.j_9394494891.jpg"
    ],
    "video": ""
  },
  {
    "id": "kizilay-sunum",
    "title": "KIZILAY SUNUM",
    "image": "/files/images/t_1.j_4553796649.jpg",
    "description": "KIZILAY SUNUMKızılay'dan gelen yetkililer, okulumuzda kan gruplarının belirlenmesi ve kan bağışının önemi ile ilgili sunum yaptılar.",
    "gallery": [
      "/files/images/t_1.j_4553796649.jpg",
      "/files/images/t_2.j_2348596454.jpg",
      "/files/images/t_3.j_3561365008.jpg",
      "/files/images/t_4.j_6099206805.jpg",
      "/files/images/t_8.j_2429773212.jpg",
      "/files/images/t_9.j_660516620.jpg"
    ],
    "video": ""
  },
  {
    "id": "okul-meclis-baskan-secimi",
    "title": "OKUL MECLİS BAŞKAN SEÇİMİ",
    "image": "/files/images/t_1.j_626642108.jpg",
    "description": "OKUL MECLİS BAŞKAN SEÇİMİOkulumuzda 9/10/2013 tarihinde öğrenci meclisi başkanı ve başkan yardımcısı seçimi öğrencilerimizin veöğretmenlerimizin katılımıyla yapıldı. Adaylar sonuçları büyük bir heyecanla beklediler. Seçim sonuçlarımızı seçim kurulunda görev alan arkadaşlarımız açıkladı. Öğrencilerimize yeni görevlerinde başarılar diliyoruz.Sınıf Temsilciler Kurulu",
    "gallery": [
      "/files/images/t_1.j_626642108.jpg",
      "/files/images/t_2.j_1542932392.jpg",
      "/files/images/t_3.j_9104577899.jpg",
      "/files/images/t_4.j_7239953875.jpg"
    ],
    "video": ""
  },
  {
    "id": "5-siniflar-antalya-kampina-gidiyor",
    "title": "5. SINIFLAR ANTALYA KAMPINA GİDİYOR...",
    "image": "/files/images/t_1.j_3977014423.jpg",
    "description": "5. SINIFLAR ANTALYA KAMPINA GİDİYOR...5. Sınıflarımız öğretmenleriyle birlikte programda belirtilen etkinlikleri kapsayan kamp içinANTALYA - SİDE'ye gidiyor.ANTALYA KAMPI GÜNLÜK PROGRAMIGÜNLÜK PROGRAM8.30 - 9.30           Kahvaltı9.30 - 10.30       Etüt ( Mat - Fen)10.30 - 11.00     Hazırlık ve  Ailelerle Telefon Görüşmesi11.00 - 12.00     Spor  Etkinliği12.00 - 12.30     Hazırlanma12.30 - 13.30     Öğle Yemeği13.30 - 14.00     Hazırlanma14.00 - 17.30     Gezi  Programı17.30 - 18.00     İkindi  Kahvaltısı18.00 - 19.00     Etüt (ingilizce)19.00 - 19.30     Hazırlık Ailelerle Telefon Görüşmesi19.30 - 21.00     Akşam Yemeği21.00 - 22.00     Animasyon22.00 - 23.00     Odaya Giriş ve YatışANTALYA KAMPI PROGRAMI1.GÜN  4 KASIM 2013 PZT07.00   Stadyum önü hareket15.30   Otele giriş, dinlenme, otel aktivitelerinden faydalanma19.00   Otelde akşam yemeği21.00   Animasyonlar2.GÜN 5 KASIM 2013 SALIOtelde kahvaltıOtel fonksiyonları12.30  Öğle yemeği14.00 Side gezisi ve Manavgat Şelalesi19.00   Otelde akşam yemeği21.00   Animasyonlar3.GÜN 6 KASIM 2013 ÇARŞ.Otelde kahvaltıOtel fonksiyonları12.30 Öğle Yemeği14.00 Manavgat  Irmağı'nda tekne gezisi - titreyen Göl19.00   Otelde akşam yemeği21.00   Animasyonlar4.GÜN 7 KASIM 2013 PERŞ.Otelde kahvaltıOtel fonksiyonları12.30 Öğle Yemeği14.00 Antalya şehir gezisi ve alışveriş19.00   Otelde akşam yemeği21.00   Animasyonlar5.GÜN 8 KASIM 2013 CUMAOtelde kahvaltıOtel fonksiyonları12.30 Öğle Yemeği14.00 Perge Antik Kenti  ve Aspendos Gezisi19.00   Otelde akşam yemeği21.00   Animasyonlar6.GÜN 9 KASIM 2013 CTS.Otelde kahvaltıOtel fonksiyonları12.30 Öğle Yemeği14.00 Otelden AyrılışAlanya gezisi ve alışveriş için serbest  zaman22.00   Mersin'e  tahmini varış.",
    "gallery": [
      "/files/images/t_1.j_3977014423.jpg",
      "/files/images/t_2.j_6093255877.jpg",
      "/files/images/t_3.j_6172448993.jpg",
      "/files/images/t_KAM_7658807635.jpg",
      "/files/images/t_111_1402398944.jpg"
    ],
    "video": ""
  },
  {
    "id": "6-siniflar-hucre-modelleri-etkinligi",
    "title": "6. SINIFLAR HÜCRE MODELLERİ ETKİNLİĞİ",
    "image": "/files/images/t_1.j_2949182391.jpg",
    "description": "6. SINIFLAR HÜCRE MODELLERİ ETKİNLİĞİ6. Sınıflarımız ile birlikte Fen Bilimleri ve Görsel Sanatlar dersi işbirliği ile gerçekleşen etkinliğimizde\"Hücre Modellerini\"cam boyama tekniğiyle uygulamalı olarak görselleştirdik.",
    "gallery": [
      "/files/images/t_1.j_2949182391.jpg",
      "/files/images/t_2.j_6353265643.jpg",
      "/files/images/t_3.j_6588098407.jpg",
      "/files/images/t_4.j_1333581806.jpg",
      "/files/images/t_5.j_15985370.jpg"
    ],
    "video": ""
  },
  {
    "id": "ortaokul-kahvalti-etkinligi",
    "title": "ORTAOKUL KAHVALTI ETKİNLİĞİ",
    "image": "/files/images/t_1.j_8773309588.jpg",
    "description": "ORTAOKUL KAHVALTI ETKİNLİĞİOkulumuz 28 Eylül Cumartesi günü öğrencilerimiz, velilerimiz ve öğretmenlerimizin katılımıyla bir \"Kahvaltı Etkinliği\" organizasyonu düzenlemiştir. Yüksek bir katılım oranıyla gerçekleşen bu organizasyon velilerimizle öğretmenlerimizin birbirleriyle olan ilişkilerinin daha sıcak ve samimi olarak gelişmesi, paylaşımların artması yönünden çok yararlı olmuştur. Gelişim Koleji ailesi olarak öğrencilerimizin ve velilerimizin beklentilerini daha iyi anlamak yönünden bu organizasyonların önemli olduğunu düşünüyoruz. Bu çoşkunun, birlikteliğin ve paylaşımların devamlı olması dileğiyle...",
    "gallery": [
      "/files/images/t_1.j_8773309588.jpg",
      "/files/images/t_2.j_9453546404.jpg",
      "/files/images/t_3.j_8796655535.jpg",
      "/files/images/t_4.j_2850000262.jpg",
      "/files/images/t_5.j_2637140155.jpg",
      "/files/images/t_6.j_5247308612.jpg",
      "/files/images/t_7.j_3413965106.jpg",
      "/files/images/t_8.j_8303338885.jpg",
      "/files/images/t_9.j_1043054462.jpg"
    ],
    "video": ""
  },
  {
    "id": "guney-gelisim-koleji-cok-sesli-polifonik-korosu-sertifikalrini-aldi",
    "title": "GÜNEY GELİŞİM KOLEJİ (ÇOK SESLİ) POLİFONİK KOROSU SERTİFİKALRINI ALDI.",
    "image": "/files/images/t_DSC_187799335.JPG",
    "description": "GÜNEY GELİŞİM KOLEJİ (ÇOK SESLİ) POLİFONİK KOROSU SERTİFİKALRINI ALDI.2012 - 2013 Eğitim Öğretim yılı boyunca Çarşamba günleri azimle çalışmalarını sürdüren koromuz,27 Nisan Cumartesi günü 15.Nevit Kodallı Polifonik Korolar Şenliğine katıldı.Kültür Merkezinde büyük alkışlarla ödüllerini alan koromuz; bu sabah da başarı belgelerini alıp; 'Burger King' de öğle yemeği yiyerek 2012-2013 koro çalışmalarını tamamladılar.Eğlenceli bir gün geçiren koromuzu kutlar başarılanın devamını dileriz.",
    "gallery": [
      "/files/images/t_DSC_187799335.JPG",
      "/files/images/t_DSC_1034356952.JPG",
      "/files/images/t_DSC_7634698748.JPG",
      "/files/images/t_DSC_9841577410.JPG"
    ],
    "video": ""
  },
  {
    "id": "turk-ermeni-iliskileri-konulu-sunum",
    "title": "``Türk Ermeni İlişkileri`` Konulu Sunum",
    "image": "/files/images/t_DSC_4435998797.JPG",
    "description": "``Türk Ermeni İlişkileri`` Konulu Sunum“Türk Ermeni İlişkileri” konulu sunumu 8A sınıfından Ozan Gündinç,8B sınıfından Buket Erdem ve Yağmur Ambar öğretmenleri Mürüvvet Öncüİle birlikte gerçekleştirdiler.Tarihi gerçeklerin farklı kaynaklardan okutularak değerlendirilmesi gerektiği veTarih bilincinin oluşmasının önemi kavratıldı.",
    "gallery": [
      "/files/images/t_DSC_4435998797.JPG"
    ],
    "video": ""
  },
  {
    "id": "fen-bilimleri-7-sinif-ogrencilerimize-yonelik-mu-kulak-burun-bogaz-kbb-hastaliklari-uzmani-prof-drkemal-gorur",
    "title": "Fen Bilimleri 7. sınıf öğrencilerimize yönelik M.Ü. Kulak Burun Boğaz (KBB) Hastalıkları Uzmanı Prof. Dr.Kemal Görür",
    "image": "/images2/img2_files/logo.jpg",
    "description": "Fen Bilimleri 7. sınıf öğrencilerimize yönelik M.Ü. Kulak Burun Boğaz (KBB) Hastalıkları Uzmanı Prof. Dr.Kemal GörürFen Bilimleri 7. sınıf öğrencilerimize yönelik M.Ü. Kulak Burun Boğaz (KBB) Hastalıkları Uzmanı Prof. Dr.Kemal Görür tarafından \"İşitme-Koklama-Tatma Duyu Organları\" konulu bir seminer düzenlenmiştir.İnteraktif olarak yapılan seminerde öğrencilerimizin bilgilerinin pekiştirilmesinde yardımcı olan uzmanımıza katılımından dolayı teşekkür ediyoruz.",
    "gallery": [],
    "video": ""
  },
  {
    "id": "6siniflar-mersin-universitesinde",
    "title": "6.SINIFLAR MERSİN ÜNİVERSİTESİNDE",
    "image": "/files/images/t_DSC_7255517840.JPG",
    "description": "6.SINIFLAR MERSİN ÜNİVERSİTESİNDE6.sınıf öğrencilerimiz Fen ve Teknoloji dersinde öğrendikleri hücrenin yapısı ile ilgili   bilgilerini  pekiştirmek amacıyla Mersin Üniversitesi Tıp Fakültesi Histoloji ve Embriyoloji Anabilim Dalı laboratuarlarındaydı.Elektron mikroskobu ile hücrenin organellerini görme imkanını sağladığı için Doç.Dr. Ebru BALLI ve öğretim elemanlarına teşekkürlerimizi sunarız.",
    "gallery": [
      "/files/images/t_DSC_7255517840.JPG",
      "/files/images/t_DSC_9562188983.JPG",
      "/files/images/t_DSC_2534295917.JPG",
      "/files/images/t_DSC_6462671161.JPG",
      "/files/images/t_DSC_9259454608.JPG",
      "/files/images/t_DSC_2010309100.JPG"
    ],
    "video": ""
  },
  {
    "id": "fen-bilimleri-dersinde-bobreklerimiz-ve-sagligi-semineri",
    "title": "Fen Bilimleri Dersinde ``Böbreklerimiz ve Sağlığı`` Semineri",
    "image": "/files/images/t_DSC_4370843768.JPG",
    "description": "Fen Bilimleri Dersinde ``Böbreklerimiz ve Sağlığı`` SemineriFen Bilimleri 5. ve 7. sınıf öğrencilerimize yönelik M.Ü. Üroloji Anabilim Dalı Dr.Mustafa Kaplan Çalışkan tarafından \"Böbreklerimiz ve Sağlığı\" konulu bir seminer düzenlenmiştir.İlgiyle izlenen seminerde öğrencilerimizin bilgilerinin pekiştirilmesinde yardımcı olan uzmanımıza teşekkür ediyoruz.",
    "gallery": [
      "/files/images/t_DSC_4370843768.JPG",
      "/files/images/t_DSC_4777948260.JPG",
      "/files/images/t_DSC_5247308612.JPG",
      "/files/images/t_DSC_1316339374.JPG",
      "/files/images/t_DSC_1978418231.JPG"
    ],
    "video": ""
  },
  {
    "id": "fen-bilimleri-dersinde-dis-sagligi-ve-saglikli-beslenme-semineri",
    "title": "Fen Bilimleri Dersinde ``Diş Sağlığı`` ve ``Sağlıklı Beslenme`` Semineri.",
    "image": "/files/images/t_DSC_3692895770.JPG",
    "description": "Fen Bilimleri Dersinde ``Diş Sağlığı`` ve ``Sağlıklı Beslenme`` Semineri.Fen Bilimleri dersinde 5.sınıf öğrencilerimize  üniteleri gereği edindikleri bilgileri pekiştirmek üzere \"Diş Sağlığı\" ve \"Sağlıklı Beslenme\"seminerleri düzenlenmiştir.Okulumuza gelerek öğrencilerimize bu konuda yardımcı olan Diş Dr. Nilüfer Karaselçuk ve Diyetisyen Tuba Erkal'a teşekkür ediyoruz.",
    "gallery": [
      "/files/images/t_DSC_3692895770.JPG",
      "/files/images/t_DSC_451623798.JPG",
      "/files/images/t_DSC_3795587421.JPG",
      "/files/images/t_DSC_5207483172.JPG"
    ],
    "video": ""
  },
  {
    "id": "turkce-sosyal-bilgiler-derslerinde-bilimsel-arastirma-basamaklarini-ogrenmeleri-amaciyla-6a-ve-6b",
    "title": "Türkçe- Sosyal Bilgiler derslerinde `Bilimsel Araştırma Basamakları`nı öğrenmeleri amacıyla 6A ve 6B",
    "image": "/images2/img2_files/logo.jpg",
    "description": "Türkçe- Sosyal Bilgiler derslerinde `Bilimsel Araştırma Basamakları`nı öğrenmeleri amacıyla 6A ve 6BTürkçe- Sosyal Bilgiler derslerinde 'Bilimsel Araştırma Basamakları'nı öğrenmeleri amacıyla 6/A ve 6/B sınıfı öğrencileriyle beraber İl Halk Kütüphanesi ziyaret edildi.Öğrencilerimiz bir kütüphanede nasıl davranılması gerektiğini ve araştırma yapmanın inceliklerini öğrendiler.Sosyal Bilgiler Öğretmeni              Türkçe ÖğretmenleriDerya KIDOĞLU               Emel GARİPOĞLU Şahin YILMAZ",
    "gallery": [],
    "video": ""
  },
  {
    "id": "8a-ve-8b-kahvaltida",
    "title": "8A ve 8B Kahvaltıda",
    "image": "/files/images/t_DSC_6646844745.JPG",
    "description": "8A ve 8B Kahvaltıda8/A ve 8/B sınıfı öğrenci ve öğretmenleri 2012-2013 öğretim yılına iyi bir başlangıç yapmak için Marina Teras Kafe’de kahvaltıda buluştular. Öğrencilerimiz neşeli bir şekilde geçen kahvaltıda, öğretmenleriyle sohbet edip bu yılı başarıyla bitireceklerine söz verdiler.8/A SINIF ÖĞRETMENİ             8/B ÖĞRETMENİYUSUF UĞUR                    MÜRÜVVET ÖNCÜ",
    "gallery": [
      "/files/images/t_DSC_6646844745.JPG",
      "/files/images/t_DSC_870172382.JPG",
      "/files/images/t_DSC_3063623309.JPG",
      "/files/images/t_DSC_618097187.JPG",
      "/files/images/t_DSC_9754297137.JPG"
    ],
    "video": ""
  }
];